(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GrimoireInterfaceImpl = __webpack_require__(21);

var _GrimoireInterfaceImpl2 = _interopRequireDefault(_GrimoireInterfaceImpl);

var _GomlInterfaceImpl = __webpack_require__(19);

var _GomlInterfaceImpl2 = _interopRequireDefault(_GomlInterfaceImpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = new _GrimoireInterfaceImpl2.default();
function obtainGomlInterface(query) {
    if (typeof query === "string") {
        var gomlContext = new _GomlInterfaceImpl2.default(context.queryRootNodes(query));
        var queryFunc = gomlContext.queryFunc.bind(gomlContext);
        Object.setPrototypeOf(queryFunc, gomlContext);
        return queryFunc;
    } else if (typeof query === "function") {
        context.initializedEventHandler.push(query);
    } else {
        var _gomlContext = new _GomlInterfaceImpl2.default(query);
        var _queryFunc = _gomlContext.queryFunc.bind(_gomlContext);
        Object.setPrototypeOf(_queryFunc, _gomlContext);
        return _queryFunc;
    }
}
Object.setPrototypeOf(obtainGomlInterface, context);
exports.default = obtainGomlInterface;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Namespace = __webpack_require__(7);

var _Namespace2 = _interopRequireDefault(_Namespace);

var _IdResolver = __webpack_require__(4);

var _IdResolver2 = _interopRequireDefault(_IdResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The class to identity with XML namespace feature.
 */
var NSIdentity = function () {
    function NSIdentity(qn, n) {
        _classCallCheck(this, NSIdentity);

        if (typeof qn === "string") {
            qn = qn.split(".");
        }
        if (n) {
            this._ns = _Namespace2.default.defineByArray(qn);
            this._name = n;
        } else {
            this._name = qn[qn.length - 1];
            qn = qn.slice(0, qn.length - 1);
            this._ns = _Namespace2.default.defineByArray(qn);
        }
        this._fqn = this.ns.hierarchy.concat([this.name]).join(".");
        NSIdentity._instances[this._fqn] = this;
        NSIdentity._map.add(qn.concat([this._name]));
    }

    _createClass(NSIdentity, [{
        key: "toString",
        value: function toString() {
            return this.fqn;
        }
    }, {
        key: "ns",

        /**
         * Namespace of this identity
         * @type {string}
         */
        get: function get() {
            return this._ns;
        }
        /**
         * Short name for this identity
         * @type {string}
         */

    }, {
        key: "name",
        get: function get() {
            return this._name;
        }
        /**
         * Full qualified name of this identity
         * @type {string}
         */

    }, {
        key: "fqn",
        get: function get() {
            return this._fqn;
        }
    }], [{
        key: "fromFQN",
        value: function fromFQN(fqn, name) {
            var hierarchy = NSIdentity._ensureQNTobeArray(fqn, name);
            fqn = hierarchy.join(".");
            var inst = NSIdentity._instances[fqn];
            if (inst) {
                return inst;
            }
            var splitted = fqn.split(".");
            return new NSIdentity(splitted);
        }
    }, {
        key: "guess",
        value: function guess() {
            for (var _len = arguments.length, hierarchy = Array(_len), _key = 0; _key < _len; _key++) {
                hierarchy[_key] = arguments[_key];
            }

            return NSIdentity._from(hierarchy);
        }
    }, {
        key: "clear",
        value: function clear() {
            NSIdentity._instances = {};
            NSIdentity._mapBackingField = new _IdResolver2.default();
        }
        /**
         * return instance if exists.
         * generate and return new instanse if not exist id has same fqn.
         * @param  {string[]}   hierarchy [description]
         * @return {NSIdentity}           [description]
         */

    }, {
        key: "_from",
        value: function _from(hierarchy) {
            var fqn = hierarchy.join(".");
            var inst = NSIdentity._instances[fqn];
            if (inst) {
                return inst;
            }
            return NSIdentity.fromFQN(NSIdentity._map.resolve(_Namespace2.default.defineByArray(hierarchy)));
        }
    }, {
        key: "_ensureQNTobeArray",
        value: function _ensureQNTobeArray(arg1, name) {
            if (name) {
                return NSIdentity._ensureQNTobeArray(arg1.extend(name));
            }
            if (typeof arg1 === "string") {
                return arg1.split(".");
            }
            if (Array.isArray(arg1)) {
                return arg1;
            }
            return arg1.hierarchy;
        }
    }, {
        key: "_map",
        get: function get() {
            if (this._mapBackingField === void 0) {
                this._mapBackingField = new _IdResolver2.default();
            }
            return this._mapBackingField;
        }
    }]);

    return NSIdentity;
}();

exports.default = NSIdentity;

NSIdentity._instances = {};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// import Namespace from "./Namespace";


var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _NSDictionary = __webpack_require__(6);

var _NSDictionary2 = _interopRequireDefault(_NSDictionary);

var _ComponentDeclaration = __webpack_require__(16);

var _ComponentDeclaration2 = _interopRequireDefault(_ComponentDeclaration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Provides static methods to ensure arguments are valid type.
 */
var Ensure = function () {
    function Ensure() {
        _classCallCheck(this, Ensure);
    }

    _createClass(Ensure, null, [{
        key: "tobeComponentIdentity",
        value: function tobeComponentIdentity(component) {
            if (typeof component === "function") {
                var obj = _ComponentDeclaration2.default.ctorMap.find(function (o) {
                    return o.ctor === component;
                });
                if (obj) {
                    component = obj.name;
                } else {
                    throw new Error("Specified constructor have not registered to current context.");
                }
            } else {
                component = Ensure.tobeNSIdentity(component);
            }
            return component;
        }
        /**
         * Ensure specified str being string
         * @param  {string | number}      str [description]
         * @return {string}      [description]
         */

    }, {
        key: "tobeString",
        value: function tobeString(str) {
            if (typeof str === "string") {
                return str;
            } else if (typeof str === "number") {
                return str.toString();
            } else {
                throw new Error("Specified argument can not convert into string");
            }
        }
        /**
         * Ensure specified number being number
         * @param  {string | number}      str [description]
         * @return {string}      [description]
         */

    }, {
        key: "tobeNumber",
        value: function tobeNumber(num) {
            if (typeof num === "string") {
                return parseInt(num, 10);
            } else if (typeof num === "number") {
                return num;
            } else {
                throw new Error("specified argument can not be converted into number");
            }
        }
        /**
         * string or NSIdentity ensure to be NSIdentity.
         * @param  {Name}       name [description]
         * @return {NSIdentity}      [description]
         */

    }, {
        key: "tobeNSIdentity",
        value: function tobeNSIdentity(name) {
            if (!name) {
                throw Error("argument can not be null or undefined.");
            }
            if (typeof name === "string") {
                return _NSIdentity2.default.guess(name);
            } else {
                return name;
            }
        }
    }, {
        key: "tobeNSIdentityArray",
        value: function tobeNSIdentityArray(names) {
            if (!names) {
                return [];
            }
            var newArr = [];
            for (var i = 0; i < names.length; i++) {
                newArr.push(this.tobeNSIdentity(names[i]));
            }
            return newArr;
        }
    }, {
        key: "tobeNSDictionary",
        value: function tobeNSDictionary(dict) {
            if (!dict) {
                return new _NSDictionary2.default();
            }
            if (dict instanceof _NSDictionary2.default) {
                return dict;
            } else {
                var newDict = new _NSDictionary2.default();
                for (var key in dict) {
                    newDict.set(_NSIdentity2.default.guess(key), dict[key]);
                }
                return newDict;
            }
        }
    }, {
        key: "tobeMessage",
        value: function tobeMessage(message) {
            if (message.startsWith("$")) {
                if (message.startsWith("$$")) {
                    return message;
                } else {
                    return "$" + message;
                }
            } else {
                return "$$" + message;
            }
        }
        /**
         * string, NSIdentity or constructor ensure to be constructor.
         * return null if identity is not registered as component.
         * @param  {[type]} typeofc==="function" [description]
         * @return {[type]}                      [description]
         */

    }, {
        key: "tobeComponentConstructor",
        value: function tobeComponentConstructor(c) {
            if (typeof c === "function") {
                return c;
            } else {
                var dec = _GrimoireInterface2.default.componentDeclarations.get(c);
                if (dec) {
                    return dec.ctor;
                }
                return null;
            }
        }
    }, {
        key: "tobeFQN",
        value: function tobeFQN(name) {
            if (typeof name === "string") {
                if (Ensure.checkFQNString(name)) {
                    return name.substring(1);
                }
                return null;
            } else {
                return name.fqn;
            }
        }
    }, {
        key: "checkFQNString",
        value: function checkFQNString(name) {
            return name.startsWith("_");
        }
    }]);

    return Ensure;
}();

exports.default = Ensure;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Utility = function () {
    function Utility() {
        _classCallCheck(this, Utility);
    }

    _createClass(Utility, null, [{
        key: "w",
        value: function w(message) {
            if (_GrimoireInterface2.default.debug) {
                console.warn(message);
            }
        }
    }, {
        key: "isCamelCase",
        value: function isCamelCase(str) {
            return (/^[A-Z][a-zA-Z0-9]*$/.test(str)
            );
        }
    }, {
        key: "isSnakeCase",
        value: function isSnakeCase(str) {
            return (/^[a-z0-9\-]+$/.test(str)
            );
        }
    }, {
        key: "flat",
        value: function flat(array) {
            var count = 0;
            for (var i = 0; i < array.length; i++) {
                count += array[i].length;
            }
            var ret = new Array(count);
            count = 0;
            for (var _i = 0; _i < array.length; _i++) {
                var ar = array[_i];
                for (var j = 0; j < ar.length; j++) {
                    ret[count] = ar[j];
                    count++;
                }
            }
            return ret;
        }
    }, {
        key: "flatMap",
        value: function flatMap(source, map) {
            var c = new Array(source.length);
            for (var i = 0; i < source.length; i++) {
                c[i] = map(source[i]);
            }
            return Utility.flat(c);
        }
    }, {
        key: "sum",
        value: function sum(array) {
            var total = 0;
            for (var i = 0; i < array.length; i++) {
                total += array[i];
            }
            return total;
        }
    }, {
        key: "remove",
        value: function remove(array, target) {
            var index = -1;
            for (var i = 0; i < array.length; i++) {
                if (target === array[i]) {
                    index = i;
                    break;
                }
            }
            if (index < 0) {
                return false;
            }
            array.splice(index, 1);
            return true;
        }
        /**
         * 重複がなければtrue
         */

    }, {
        key: "checkOverlap",
        value: function checkOverlap(array) {
            var list = [];
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                if (list.indexOf(item) !== -1) {
                    return false;
                }
                list.push(item);
            }
            return true;
        }
    }]);

    return Utility;
}();

exports.default = Utility;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Namespace = __webpack_require__(7);

var _Namespace2 = _interopRequireDefault(_Namespace);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Internal use!
 * Disambiguate according to the context from the namespace hierarchy.
 * @return {[type]} [description]
 */
var IdResolver = function () {
    function IdResolver() {
        _classCallCheck(this, IdResolver);

        this._nameMap = {};
        this._FQNSet = new Set();
        this._isTerminal = false;
    }

    _createClass(IdResolver, [{
        key: "add",

        /**
         * add id to resolver context.
         * @param  {NSIdentity} id [description]
         * @return {boolean}       true if succcess adding.
         */
        value: function add(id) {
            if (!id) {
                throw new Error("Argument ns is null or undefined.");
            }
            if (id instanceof _NSIdentity2.default) {
                id = id.ns.hierarchy.concat([id.name]);
            }
            if (id.length === 0) {
                return false;
            }
            return this._add(id);
        }
        /**
         * Get all possible FQN.
         * @param  {string | string[]}    name [description]
         * @return {string[]}    list of FQN
         */

    }, {
        key: "get",
        value: function get(ns) {
            if (typeof ns === "string") {
                return this.get(_Namespace2.default.defineByArray(ns.split(".")));
            }
            var name = ns.hierarchy;
            var current_name = name[name.length - 1];
            if (!this._nameMap[current_name]) {
                return [];
            }
            var pathes = this._nameMap[current_name]._get(name.slice(0, name.length - 1));
            var res = [];
            for (var i = 0; i < pathes.length; i++) {
                var a = pathes[i];
                a.push(current_name);
                res.push(a.join("."));
            }
            return res;
        }
    }, {
        key: "resolve",
        value: function resolve(name) {
            if (typeof name === "string") {
                return this.resolve(_Namespace2.default.defineByArray(name.split(".")));
            }
            var pathes = this.get(name);
            if (pathes.length === 0) {
                throw new Error(name + " is not found in this context.");
            }
            if (pathes.length > 1) {
                throw new Error(name + " is ambiguous in this context. [" + pathes.join(", ") + "]");
            }
            return pathes[0];
        }
    }, {
        key: "has",
        value: function has(name) {
            return !!this._nameMap[name];
        }
    }, {
        key: "remove",
        value: function remove(name) {
            var fqn = name.fqn.split(".");
            this._remove(fqn);
        }
    }, {
        key: "foreach",
        value: function foreach(callback) {
            this._FQNSet.forEach(callback);
        }
    }, {
        key: "_remove",
        value: function _remove(name) {
            if (name.length === 1) {
                this._nameMap[name[0]]._isTerminal = false;
            } else {
                var next = this._nameMap[name[name.length - 1]];
                next._remove(name.slice(0, name.length - 1));
            }
        }
    }, {
        key: "_get",
        value: function _get(name) {
            var res = [];
            if (name.length === 0) {
                if (this.count === 0) {
                    return [[]];
                }
                for (var key in this._nameMap) {
                    var match = this._nameMap[key]._get([]);
                    for (var i = 0; i < match.length; i++) {
                        var m = match[i];
                        m.push(key);
                        res.push(m);
                    }
                }
                if (this._isTerminal) {
                    res.push([]);
                }
                return res;
            }
            var current_name = name[name.length - 1];
            for (var _key in this._nameMap) {
                var _match = _key === current_name ? this._nameMap[_key]._get(name.slice(0, name.length - 1)) : this._nameMap[_key]._get(name);
                if (_match.length !== 0) {
                    for (var _i = 0; _i < _match.length; _i++) {
                        var _m = _match[_i];
                        _m.push(_key);
                        res.push(_m);
                    }
                }
            }
            return res;
        }
        /**
         * nameはドットをフラット化済。nameの長さは0ではない。重複があればfalse新規ならtrueを返す。
         * @param  {string[]} name [description]
         * @return {boolean}       [description]
         */

    }, {
        key: "_add",
        value: function _add(id) {
            var fqn = id.join(".");
            if (this._FQNSet.has(fqn)) {
                return false;
            }
            this._FQNSet.add(fqn);
            if (!this._nameMap[id[id.length - 1]]) {
                this._nameMap[id[id.length - 1]] = new IdResolver();
            }
            var next = id.slice(0, id.length - 1);
            if (next.length === 0) {
                this._nameMap[id[id.length - 1]]._isTerminal = true;
            } else {
                this._nameMap[id[id.length - 1]].add(next);
            }
            return true;
        }
    }, {
        key: "count",
        get: function get() {
            return this._FQNSet.size;
        }
    }]);

    return IdResolver;
}();

exports.default = IdResolver;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Constants = function () {
    function Constants() {
        _classCallCheck(this, Constants);
    }

    _createClass(Constants, null, [{
        key: "defaultNamespace",
        get: function get() {
            return "grimoirejs";
        }
    }, {
        key: "x_gr_id",
        get: function get() {
            return "x-gr-id";
        }
    }]);

    return Constants;
}();

exports.default = Constants;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _IdResolver = __webpack_require__(4);

var _IdResolver2 = _interopRequireDefault(_IdResolver);

var _Namespace = __webpack_require__(7);

var _Namespace2 = _interopRequireDefault(_Namespace);

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NSDictionary = function () {
    function NSDictionary() {
        _classCallCheck(this, NSDictionary);

        this._fqnObjectMap = {};
        this._idResolver = new _IdResolver2.default();
    }

    _createClass(NSDictionary, [{
        key: "set",
        value: function set(key, value) {
            this._fqnObjectMap[key.fqn] = value;
            this._idResolver.add(key);
        }
    }, {
        key: "delete",
        value: function _delete(key) {
            if (this._fqnObjectMap[key.fqn] !== void 0) {
                delete this._fqnObjectMap[key.fqn];
                this._idResolver.remove(key);
                return true;
            }
            return false;
        }
    }, {
        key: "get",
        value: function get(arg1) {
            if (!arg1) {
                throw new Error("NSDictionary.get() can not recieve args null or undefined.");
            }
            if (typeof arg1 === "string") {
                var fqn = _Ensure2.default.tobeFQN(arg1);
                if (fqn) {
                    return this._fqnObjectMap[fqn];
                }
                var name = arg1.split(".");
                var res = this._idResolver.get(_Namespace2.default.defineByArray(name));
                // const namedMap = this._nameObjectMap[arg1];
                if (res.length === 0) {
                    return null; // not exist.
                }
                if (res.length === 1) {
                    return this._fqnObjectMap[res[0]];
                } else {
                    throw new Error("Specified tag name " + arg1 + " is ambiguous to identify.");
                }
            } else {
                if (arg1 instanceof _NSIdentity2.default) {
                    return this._fqnObjectMap[arg1.fqn];
                } else {
                    if (arg1.namespaceURI) {
                        return this.get(arg1.namespaceURI + "." + arg1.localName);
                    }
                    return this.get(arg1.localName);
                }
            }
        }
        /**
         * Check if name has possibility of multiple values.
         * @param  {string}  name [description]
         * @return {boolean}      Whether the name has multiple values.
         */

    }, {
        key: "isAmbiguous",
        value: function isAmbiguous(name) {
            return this._idResolver.get(_Namespace2.default.defineByArray(name.split("."))).length > 1;
        }
    }, {
        key: "has",
        value: function has(name) {
            return this._idResolver.get(_Namespace2.default.defineByArray(name.split("."))).length !== 0;
        }
    }, {
        key: "pushDictionary",
        value: function pushDictionary(dict) {
            var _this = this;

            dict.forEach(function (value, keyFQN) {
                var id = _NSIdentity2.default.fromFQN(keyFQN);
                _this.set(id, value);
            });
            return this;
        }
    }, {
        key: "hasMatchingValue",
        value: function hasMatchingValue(name) {
            var resolver = new _IdResolver2.default();
            resolver.add(name);
            var match = void 0;
            for (var key in this._fqnObjectMap) {
                var v = resolver.get(_Namespace2.default.defineByArray(key.split(".")));
                if (v.length === 1) {
                    if (match === void 0) {
                        match = key;
                    } else {
                        throw new Error("matching attribute is ambiguous. It has following possibilities " + match + " " + key);
                    }
                }
            }
            if (match) {
                return this._fqnObjectMap[match];
            }
            return void 0;
        }
    }, {
        key: "toArray",
        value: function toArray() {
            var _this2 = this;

            var ret = [];
            Object.keys(this._fqnObjectMap).forEach(function (key) {
                ret.push(_this2._fqnObjectMap[key]);
            });
            return ret;
        }
    }, {
        key: "clone",
        value: function clone() {
            var dict = new NSDictionary();
            return dict.pushDictionary(this);
        }
    }, {
        key: "forEach",
        value: function forEach(callback) {
            var _this3 = this;

            Object.keys(this._fqnObjectMap).forEach(function (key) {
                callback(_this3._fqnObjectMap[key], key);
            });
            return this;
        }
    }, {
        key: "map",
        value: function map(callback) {
            var ret = new NSDictionary();
            this.forEach(function (val, fqn) {
                var id = _NSIdentity2.default.fromFQN(fqn);
                ret.set(id, callback(val, fqn));
            });
            return ret;
        }
    }, {
        key: "clear",
        value: function clear() {
            this._fqnObjectMap = {};
            this._idResolver = new _IdResolver2.default();
        }
    }]);

    return NSDictionary;
}();

exports.default = NSDictionary;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _Utility = __webpack_require__(3);

var _Utility2 = _interopRequireDefault(_Utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Namespace = function () {
    _createClass(Namespace, [{
        key: "extend",
        value: function extend(extension) {
            return new Namespace(this._ns.concat([extension]));
        }
    }, {
        key: "for",
        value: function _for(name) {
            return _NSIdentity2.default.fromFQN(this, name);
        }
    }, {
        key: "toString",
        value: function toString() {
            return this.qualifiedName;
        }
    }, {
        key: "hierarchy",
        get: function get() {
            return this._ns;
        }
    }, {
        key: "qualifiedName",
        get: function get() {
            return this._ns.join(".");
        }
    }], [{
        key: "define",

        /**
         * create new Namespace instance.
         * You can include dots in the name
         * @param  {string[]}  ...name [description]
         * @return {Namespace}         [description]
         */
        value: function define() {
            for (var _len = arguments.length, name = Array(_len), _key = 0; _key < _len; _key++) {
                name[_key] = arguments[_key];
            }

            return Namespace.defineByArray(name);
        }
    }, {
        key: "defineByArray",
        value: function defineByArray(name) {
            return new Namespace(_Utility2.default.flat(name.map(function (n) {
                return n.split(".");
            })));
        }
    }]);

    function Namespace(names) {
        _classCallCheck(this, Namespace);

        this._ns = names;
    }

    return Namespace;
}();

exports.default = Namespace;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utility = __webpack_require__(3);

var _Utility2 = _interopRequireDefault(_Utility);

var _Constants = __webpack_require__(5);

var _Constants2 = _interopRequireDefault(_Constants);

var _NodeUtility = __webpack_require__(15);

var _NodeUtility2 = _interopRequireDefault(_NodeUtility);

var _Attribute = __webpack_require__(17);

var _Attribute2 = _interopRequireDefault(_Attribute);

var _IDObject2 = __webpack_require__(13);

var _IDObject3 = _interopRequireDefault(_IDObject2);

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class for any components
 * component must be attach to node before any operation.
 */
var Component = function (_IDObject) {
    _inherits(Component, _IDObject);

    function Component() {
        _classCallCheck(this, Component);

        /**
         * Whether this component was created by nodeDeclaration
         * @type {boolean}
         */
        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));

        _this.isDefaultComponent = false;
        _this.disposed = false;
        /**
         * Flag that this component is activated or not.
         * @type {boolean}
         */
        _this._enabled = true;
        _this._awaked = false;
        _this._handlers = [];
        _this._additionalAttributesNames = [];
        _this._initializedInfo = null;
        return _this;
    }

    _createClass(Component, [{
        key: "setAttribute",

        /**
         * Set value of attribute
         * @param {string} name  [description]
         * @param {any}    value [description]
         */
        value: function setAttribute(name, value) {
            if (typeof name === "string" && _Ensure2.default.checkFQNString(name)) {
                name = this.name.fqn + "." + name; // TODO: test
            }
            var attr = this.attributes.get(name);
            if (attr) {
                attr.Value = value;
            }
        }
    }, {
        key: "getAttribute",
        value: function getAttribute(name) {
            if (typeof name === "string" && _Ensure2.default.checkFQNString(name)) {
                name = this.name.fqn + "." + name; // TODO: test
            }
            var attr = this.getAttributeRaw(name);
            if (attr) {
                return attr.Value;
            } else {
                throw new Error("attribute " + name + " is not defined in " + this.name.fqn);
            }
        }
    }, {
        key: "getAttributeRaw",
        value: function getAttributeRaw(name) {
            if (typeof name === "string" && _Ensure2.default.checkFQNString(name)) {
                name = this.name.fqn + "." + name; // TODO: test
            }
            return this.attributes.get(name);
        }
    }, {
        key: "addEnabledObserver",
        value: function addEnabledObserver(observer) {
            this._handlers.push(observer);
        }
    }, {
        key: "removeEnabledObserver",
        value: function removeEnabledObserver(observer) {
            return _Utility2.default.remove(this._handlers, observer);
        }
    }, {
        key: "resolveDefaultAttributes",
        value: function resolveDefaultAttributes(nodeAttributes) {
            var nodeAttr = nodeAttributes || {};
            if (this.isDefaultComponent) {
                this.attributes.forEach(function (attr) {
                    return attr.resolveDefaultValue(nodeAttr);
                });
            } else {
                var attrs = _NodeUtility2.default.getAttributes(this.element);
                for (var key in attrs) {
                    if (key === _Constants2.default.x_gr_id) {
                        continue;
                    }
                }
                this.attributes.forEach(function (attr) {
                    return attr.resolveDefaultValue(attrs);
                });
            }
        }
    }, {
        key: "dispose",
        value: function dispose() {
            this.node.removeComponent(this);
        }
    }, {
        key: "awake",
        value: function awake() {
            if (this._awaked) {
                return false;
            }
            this._awaked = true;
            var method = this["$$awake"];
            if (typeof method === "function") {
                method();
            }
            return true;
        }
    }, {
        key: "initialized",
        value: function initialized(info) {
            if (this._initializedInfo === info) {
                return;
            }
            this._initializedInfo = info;
            var method = this["$$initialized"];
            if (typeof method === "function") {
                method(info);
            }
        }
    }, {
        key: "__addAtribute",
        value: function __addAtribute(name, attribute) {
            console.warn(this.name.fqn + " is using '__addAtribute()'.\nthis method is deprecated because typo.\nplease use '__addAttribute() instead of.'");
            this.__addAttribute(name, attribute);
        }
        /**
         * Add additional attribute to this component.
         * @param {string}                name      [description]
         * @param {IAttributeDeclaration} attribute [description]
         */

    }, {
        key: "__addAttribute",
        value: function __addAttribute(name, attribute) {
            if (!attribute) {
                throw new Error("can not add attribute null or undefined.");
            }
            var attr = _Attribute2.default.generateAttributeForComponent(name, attribute, this);
            this.node.addAttribute(attr);
            if (this.isDefaultComponent) {
                attr.resolveDefaultValue(_NodeUtility2.default.getAttributes(this.node.element));
            } else {
                var attrs = _NodeUtility2.default.getAttributes(this.element);
                attr.resolveDefaultValue(attrs);
            }
            this._additionalAttributesNames.push(attr.name);
            return attr;
        }
    }, {
        key: "__removeAttributes",
        value: function __removeAttributes(name) {
            var _this2 = this;

            if (name) {
                var index = this._additionalAttributesNames.findIndex(function (id) {
                    return id.name === name;
                });
                if (index < 0) {
                    throw new Error("can not remove attributes :" + name);
                }
                var attrId = this._additionalAttributesNames[index];
                this.node.removeAttribute(this.attributes.get(attrId));
                this.attributes.delete(attrId);
                this._additionalAttributesNames.splice(index, 1);
            } else {
                var arr = this._additionalAttributesNames.concat();
                arr.forEach(function (id) {
                    _this2.__removeAttributes(id.name);
                });
            }
        }
    }, {
        key: "__bindAttributes",
        value: function __bindAttributes() {
            this.attributes.forEach(function (attr) {
                var name = attr.name.name;
                attr.boundTo(name);
            });
        }
    }, {
        key: "enabled",
        get: function get() {
            return this._enabled;
        },
        set: function set(val) {
            var _this3 = this;

            if (this._enabled === val) {
                return;
            }
            this._enabled = val;
            this._handlers.forEach(function (handler) {
                handler(_this3);
            });
        }
        /**
         * The dictionary which is shared in entire tree.
         * @return {NSDictionary<any>} [description]
         */

    }, {
        key: "companion",
        get: function get() {
            return this.node.companion;
        }
        /**
         * Tree interface for the tree this node is attached.
         * @return {GomlInterface} [description]
         */

    }, {
        key: "tree",
        get: function get() {
            return this.node.tree;
        }
    }, {
        key: "isActive",
        get: function get() {
            return this.enabled && !!this.node && this.node.isActive;
        }
    }]);

    return Component;
}(_IDObject3.default);

exports.default = Component;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _GomlNode = __webpack_require__(10);

var _GomlNode2 = _interopRequireDefault(_GomlNode);

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Parser of Goml to Node utilities.
 * This class do not store any nodes and goml properties.
 */
var GomlParser = function () {
    function GomlParser() {
        _classCallCheck(this, GomlParser);
    }

    _createClass(GomlParser, null, [{
        key: "parse",

        /**
         * Domをパースする
         * @param  {Element}           source    [description]
         * @param  {GomlNode}          parent    あればこのノードにaddChildされる
         * @return {GomlNode}                    ルートノード
         */
        value: function parse(source, parent) {
            var newNode = GomlParser._createNode(source);
            // Parse children recursively
            var children = source.childNodes;
            var childNodeElements = []; // for parse after .Components has resolved.
            if (children && children.length !== 0) {
                var removeTarget = [];
                for (var i = 0; i < children.length; i++) {
                    var child = children.item(i);
                    if (!GomlParser._isElement(child)) {
                        removeTarget.push(child);
                        continue;
                    }
                    if (this._isComponentsTag(child)) {
                        // parse as components
                        GomlParser._parseComponents(newNode, child);
                        removeTarget.push(child);
                    } else {
                        // parse as child node.
                        childNodeElements.push(child);
                    }
                }
                // remove unused elements
                for (var _i = 0; _i < removeTarget.length; _i++) {
                    source.removeChild(removeTarget[_i]);
                }
            }
            // generate tree
            if (parent) {
                parent.addChild(newNode, null, false);
            }
            childNodeElements.forEach(function (child) {
                GomlParser.parse(child, newNode);
            });
            return newNode;
        }
        /**
         * GomlNodeのインスタンス化。GrimoireInterfaceへの登録
         * @param  {HTMLElement}      elem         [description]
         * @param  {GomlConfigurator} configurator [description]
         * @return {GomlTreeNodeBase}              [description]
         */

    }, {
        key: "_createNode",
        value: function _createNode(elem) {
            var tagName = elem.localName;
            var recipe = _GrimoireInterface2.default.nodeDeclarations.get(elem);
            if (!recipe) {
                throw new Error("Tag \"" + tagName + "\" is not found.");
            }
            return new _GomlNode2.default(recipe, elem);
        }
        /**
         * .COMPONENTSのパース。
         * @param {GomlNode} node          アタッチされるコンポーネント
         * @param {Element}  componentsTag .COMPONENTSタグ
         */

    }, {
        key: "_parseComponents",
        value: function _parseComponents(node, componentsTag) {
            var componentNodes = componentsTag.childNodes;
            if (!componentNodes) {
                return;
            }
            for (var i = 0; i < componentNodes.length; i++) {
                var componentNode = componentNodes.item(i);
                if (!GomlParser._isElement(componentNode)) {
                    continue; // Skip if the node was not element
                }
                var componentDecl = _GrimoireInterface2.default.componentDeclarations.get(componentNode);
                if (!componentDecl) {
                    throw new Error("Component " + componentNode.tagName + " is not found.");
                }
                var component = componentDecl.generateInstance(componentNode);
                node._addComponentDirectly(component, false);
            }
        }
    }, {
        key: "_isElement",
        value: function _isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }
    }, {
        key: "_isComponentsTag",
        value: function _isComponentsTag(element) {
            var regexToFindComponent = /\.COMPONENTS$/mi; // TODO might needs to fix
            return regexToFindComponent.test(element.nodeName);
        }
    }]);

    return GomlParser;
}();

exports.default = GomlParser;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AttributeManager = __webpack_require__(20);

var _AttributeManager2 = _interopRequireDefault(_AttributeManager);

var _Utility = __webpack_require__(3);

var _Utility2 = _interopRequireDefault(_Utility);

var _Constants = __webpack_require__(5);

var _Constants2 = _interopRequireDefault(_Constants);

var _GomlParser = __webpack_require__(9);

var _GomlParser2 = _interopRequireDefault(_GomlParser);

var _XMLReader = __webpack_require__(11);

var _XMLReader2 = _interopRequireDefault(_XMLReader);

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

var _EEObject2 = __webpack_require__(12);

var _EEObject3 = _interopRequireDefault(_EEObject2);

var _NodeUtility = __webpack_require__(15);

var _NodeUtility2 = _interopRequireDefault(_NodeUtility);

var _NSDictionary = __webpack_require__(6);

var _NSDictionary2 = _interopRequireDefault(_NSDictionary);

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

var _MessageException = __webpack_require__(22);

var _MessageException2 = _interopRequireDefault(_MessageException);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GomlNode = function (_EEObject) {
    _inherits(GomlNode, _EEObject);

    /**
     * create new instance.
     * @param  {NodeDeclaration} recipe  作成するノードのDeclaration
     * @param  {Element}         element 対応するDomElement
     * @return {[type]}                  [description]
     */
    function GomlNode(recipe, element) {
        _classCallCheck(this, GomlNode);

        var _this = _possibleConstructorReturn(this, (GomlNode.__proto__ || Object.getPrototypeOf(GomlNode)).call(this));

        _this.children = [];
        _this._parent = null;
        _this._root = null;
        _this._tree = (0, _GrimoireInterface2.default)([_this]);
        _this._companion = new _NSDictionary2.default();
        _this._isActive = false;
        _this._messageCache = {};
        _this._deleted = false;
        _this._mounted = false;
        _this._enabled = true;
        _this._defaultValueResolved = false;
        _this._initializedInfo = null;
        if (!recipe) {
            throw new Error("recipe must not be null");
        }
        if (!recipe.resolvedDependency) {
            recipe.resolveDependency();
        }
        _this.nodeDeclaration = recipe;
        _this.element = element ? element : document.createElementNS(recipe.name.ns.qualifiedName, recipe.name.name);
        _this.componentsElement = document.createElement("COMPONENTS");
        _this._root = _this;
        _this._components = [];
        _this._attributeManager = new _AttributeManager2.default(recipe.name.name);
        _this.element.setAttribute(_Constants2.default.x_gr_id, _this.id);
        var defaultComponentNames = recipe.defaultComponentsActual;
        // instanciate default components
        defaultComponentNames.forEach(function (id) {
            _this.addComponent(id, null, true);
        });
        // register to GrimoireInterface.
        _GrimoireInterface2.default.nodeDictionary[_this.id] = _this;
        return _this;
    }
    /**
     * Get actual goml node from element of xml tree.
     * @param  {Element}  elem [description]
     * @return {GomlNode}      [description]
     */


    _createClass(GomlNode, [{
        key: "getChildrenByClass",

        /**
         * search from children node by class property.
         * return all nodes has same class as given.
         * @param  {string}     className [description]
         * @return {GomlNode[]}           [description]
         */
        value: function getChildrenByClass(className) {
            var nodes = this.element.getElementsByClassName(className);
            var array = new Array(nodes.length);
            for (var i = 0; i < nodes.length; i++) {
                array[i] = GomlNode.fromElement(nodes.item(i));
            }
            return array;
        }
        /**
         * Query children from current node.
         * @param  {string}   query [description]
         * @return GomlNode[]       [description]
         */

    }, {
        key: "queryChildren",
        value: function queryChildren(query) {
            var nodes = this.element.querySelectorAll(query);
            var array = new Array(nodes.length);
            for (var i = 0; i < nodes.length; i++) {
                array[i] = GomlNode.fromElement(nodes.item(i));
            }
            return array;
        }
        /**
         * search from children node by name property.
         * return all nodes has same name as given.
         * @param  {string}     nodeName [description]
         * @return {GomlNode[]}          [description]
         */

    }, {
        key: "getChildrenByNodeName",
        value: function getChildrenByNodeName(nodeName) {
            var nodes = this.element.getElementsByTagName(nodeName);
            var array = new Array(nodes.length);
            for (var i = 0; i < nodes.length; i++) {
                array[i] = GomlNode.fromElement(nodes.item(i));
            }
            return array;
        }
    }, {
        key: "remove",
        value: function remove() {
            this.children.forEach(function (c) {
                c.remove();
            });
            this._sendMessageForced("$$dispose");
            this.removeAllListeners();
            delete _GrimoireInterface2.default.nodeDictionary[this.id];
            if (this._parent) {
                this._parent.detachChild(this);
            } else {
                this.setMounted(false);
                if (this.element.parentNode) {
                    this.element.parentNode.removeChild(this.element);
                }
            }
            this._deleted = true;
        }
        /**
         * send message to this node.
         * invoke component method has same name as message if this node isActive.
         * @param  {string}  message [description]
         * @param  {any}     args    [description]
         * @return {boolean}         is this node active.
         */

    }, {
        key: "sendMessage",
        value: function sendMessage(message, args) {
            if (!this.isActive) {
                return false;
            }
            message = _Ensure2.default.tobeMessage(message);
            this._sendMessage(message, args);
            return true;
        }
    }, {
        key: "broadcastMessage",
        value: function broadcastMessage(arg1, arg2, arg3) {
            if (!this.enabled || !this.mounted) {
                return;
            }
            if (typeof arg1 === "number") {
                var range = arg1;
                var message = _Ensure2.default.tobeMessage(arg2);
                var args = arg3;
                this._broadcastMessage(message, args, range);
            } else {
                var _message = _Ensure2.default.tobeMessage(arg1);
                var _args = arg2;
                this._broadcastMessage(_message, _args, -1);
            }
        }
    }, {
        key: "append",
        value: function append(tag) {
            var _this2 = this;

            var elems = _XMLReader2.default.parseXML(tag);
            var ret = [];
            elems.forEach(function (elem) {
                var child = _GomlParser2.default.parse(elem);
                _this2.addChild(child);
                ret.push(child);
            });
            return ret;
        }
        /**
         * add new instance created by given name and attributes for this node as child.
         * @param {string |   NSIdentity} nodeName      [description]
         * @param {any    }} attributes   [description]
         */

    }, {
        key: "addChildByName",
        value: function addChildByName(nodeName, attributes) {
            var nodeDec = _GrimoireInterface2.default.nodeDeclarations.get(nodeName);
            var node = new GomlNode(nodeDec);
            if (attributes) {
                for (var key in attributes) {
                    node.setAttribute(key, attributes[key]);
                }
            }
            this.addChild(node);
            return node;
        }
        /**
         * Add child for this node.
         * @param {GomlNode} child            child node to add.
         * @param {number}   index            index for insert.なければ末尾に追加
         * @param {[type]}   elementSync=true trueのときはElementのツリーを同期させる。（Elementからパースするときはfalseにする）
         */

    }, {
        key: "addChild",
        value: function addChild(child, index) {
            var elementSync = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (child._deleted) {
                throw new Error("deleted node never use.");
            }
            if (index != null && typeof index !== "number") {
                throw new Error("insert index should be number or null or undefined.");
            }
            // add process.
            var insertIndex = index == null ? this.children.length : index;
            this.children.splice(insertIndex, 0, child);
            child._parent = this;
            child._tree = this._tree;
            child._companion = this._companion;
            // sync html
            if (elementSync) {
                var referenceElement = this.element[_NodeUtility2.default.getNodeListIndexByElementIndex(this.element, insertIndex)];
                this.element.insertBefore(child.element, referenceElement);
            }
            // mounting
            if (this.mounted) {
                child.setMounted(true);
            }
            // send initializedInfo if needed
            if (this._initializedInfo) {
                child.sendInitializedMessage(this._initializedInfo);
            }
        }
    }, {
        key: "callRecursively",
        value: function callRecursively(func) {
            return this._callRecursively(func, function (n) {
                return n.children;
            });
        }
        /**
         * delete child node.
         * @param {GomlNode} child Target node to be inserted.
         */

    }, {
        key: "removeChild",
        value: function removeChild(child) {
            var node = this.detachChild(child);
            if (node) {
                node.remove();
            }
        }
        /**
         * detach given node from this node if target is child of this node.
         * return null if target is not child of this node.
         * @param  {GomlNode} child [description]
         * @return {GomlNode}       detached node.
         */

    }, {
        key: "detachChild",
        value: function detachChild(target) {
            // search child.
            var index = this.children.indexOf(target);
            if (index === -1) {
                return null;
            }
            target.setMounted(false);
            target._parent = null;
            this.children.splice(index, 1);
            // html sync
            this.element.removeChild(target.element);
            return target;
        }
        /**
         * detach this node from parent.
         */

    }, {
        key: "detach",
        value: function detach() {
            if (this.parent) {
                this.parent.detachChild(this);
            } else {
                throw new Error("root Node cannot be detached.");
            }
        }
    }, {
        key: "getAttribute",
        value: function getAttribute(attrName) {
            return this._attributeManager.getAttribute(attrName);
        }
    }, {
        key: "getAttributeRaw",
        value: function getAttributeRaw(attrName) {
            return this._attributeManager.getAttributeRaw(attrName);
        }
    }, {
        key: "setAttribute",
        value: function setAttribute(attrName, value) {
            var ignoireFreeze = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var attrIds = this._attributeManager.guess(attrName);
            if (attrIds.length === 0) {
                this._attributeManager.setAttribute(typeof attrName === "string" ? attrName : attrName.fqn, value);
            }
            for (var i = 0; i < attrIds.length; i++) {
                var id = attrIds[i];
                if (!ignoireFreeze && this.isFreezeAttribute(id.fqn)) {
                    throw new Error("attribute " + id.fqn + " can not set. Attribute is frozen. ");
                }
                this._attributeManager.setAttribute(id.fqn, value);
            }
        }
        /**
         *  Internal use!
         *  Add new attribute. In most of case, users no need to call this method.
         *  Use __addAttribute in Component should be used instead.
         */

    }, {
        key: "addAttribute",
        value: function addAttribute(attr) {
            return this._attributeManager.addAttribute(attr);
        }
        /**
         * Internal use!
         * Update mounted status and emit events
         * @param {boolean} mounted Mounted status.
         */

    }, {
        key: "setMounted",
        value: function setMounted(mounted) {
            if (this._mounted === mounted) {
                return;
            }
            if (mounted) {
                this._mount();
                for (var i = 0; i < this.children.length; i++) {
                    this.children[i].setMounted(mounted);
                }
            } else {
                for (var _i = 0; _i < this.children.length; _i++) {
                    this.children[_i].setMounted(mounted);
                }
                this._sendMessageForced("unmount");
                this._isActive = false;
                this._tree = (0, _GrimoireInterface2.default)([this]);
                this._companion = new _NSDictionary2.default();
                this._mounted = mounted;
            }
        }
        /**
         * Get index of this node from parent.
         * @return {number} number of index.
         */

    }, {
        key: "removeAttribute",

        /**
         * remove attribute from this node.
         * @param {Attribute} attr [description]
         */
        value: function removeAttribute(attr) {
            return this._attributeManager.removeAttribute(attr);
        }
        /**
         * attach component to this node.
         * @param {Component} component [description]
         */

    }, {
        key: "addComponent",
        value: function addComponent(component, attributes) {
            var isDefaultComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            component = _Ensure2.default.tobeComponentIdentity(component);
            var declaration = _GrimoireInterface2.default.componentDeclarations.get(component);
            if (!declaration) {
                throw new Error("component '" + _Ensure2.default.tobeNSIdentity(component).fqn + "' is not defined.");
            }
            var instance = declaration.generateInstance();
            attributes = attributes || {};
            for (var key in attributes) {
                instance.setAttribute(key, attributes[key]);
            }
            this._addComponentDirectly(instance, isDefaultComponent);
            return instance;
        }
        /**
         * Internal use!
         * Should not operate by users or plugin developpers
         * @param {Component} component          [description]
         * @param {boolean}   isDefaultComponent [description]
         */

    }, {
        key: "_addComponentDirectly",
        value: function _addComponentDirectly(component, isDefaultComponent) {
            var _this3 = this;

            if (component.node || component.disposed) {
                throw new Error("component never change attached node");
            }
            // resetting cache
            this._messageCache = {}; // TODO: optimize.
            component.isDefaultComponent = !!isDefaultComponent;
            component.node = this;
            var referenceElement = this.componentsElement[_NodeUtility2.default.getNodeListIndexByElementIndex(this.componentsElement, this._components.length)];
            this.componentsElement.insertBefore(component.element, referenceElement);
            // bind this for message reciever.
            var propNames = [];
            var o = component;
            while (o) {
                propNames = propNames.concat(Object.getOwnPropertyNames(o));
                o = Object.getPrototypeOf(o);
            }
            propNames.filter(function (name) {
                return name.startsWith("$") && typeof component[name] === "function";
            }).forEach(function (method) {
                component["$" + method] = component[method].bind(component);
            });
            this._components.push(component);
            // attributes should be exposed on node
            component.attributes.forEach(function (p) {
                return _this3.addAttribute(p);
            });
            if (this._defaultValueResolved) {
                component.attributes.forEach(function (p) {
                    return p.resolveDefaultValue(_NodeUtility2.default.getAttributes(_this3.element));
                });
            }
            if (this._mounted) {
                component.resolveDefaultAttributes(null); // here must be optional component.should not use node element attributes.
                this._sendMessageForcedTo(component, "awake");
                this._sendMessageForcedTo(component, "mount");
            }
            // sending `initialized` message if needed.
            if (this._initializedInfo) {
                component.initialized(this._initializedInfo);
            }
        }
    }, {
        key: "removeComponents",
        value: function removeComponents(component) {
            var _this4 = this;

            var result = false;
            var removeTargets = [];
            component = _Ensure2.default.tobeComponentIdentity(component);
            for (var i = 0; i < this._components.length; i++) {
                var c = this._components[i];
                if (c.name.fqn === component.fqn) {
                    removeTargets.push(c);
                }
            }
            removeTargets.forEach(function (c) {
                var b = _this4.removeComponent(c);
                result = result || b;
            });
            return result;
        }
    }, {
        key: "removeComponent",
        value: function removeComponent(component) {
            var index = this._components.indexOf(component);
            if (index !== -1) {
                this._sendMessageForcedTo(component, "unmount");
                this._sendMessageForcedTo(component, "dispose");
                this.componentsElement.removeChild(component.element);
                this._components.splice(index, 1);
                this._messageCache = {}; // TODO:optimize.
                delete component.node;
                component.disposed = true;
                delete _GrimoireInterface2.default.componentDictionary[component.id];
                return true;
            }
            return false;
        }
    }, {
        key: "getComponents",
        value: function getComponents(filter) {
            if (!filter) {
                return this._components;
            } else {
                var ctor = _Ensure2.default.tobeComponentConstructor(filter);
                if (!ctor) {
                    return [];
                }
                return this._components.filter(function (c) {
                    return c instanceof ctor;
                });
            }
        }
        /**
         * search component by name from this node.
         * @param  {Name}  name [description]
         * @return {Component}   component found first.
         */

    }, {
        key: "getComponent",
        value: function getComponent(name) {
            // 事情により<T extends Component>とはできない。
            // これはref/Node/Componentによって参照されるのが外部ライブラリにおけるコンポーネントであるが、
            // src/Node/Componentがこのプロジェクトにおけるコンポーネントのため、別のコンポーネントとみなされ、型の制約をみたさなくなるからである。
            if (!name) {
                throw new Error("name must not be null or undefined");
            } else if (typeof name === "function") {
                return this._components.find(function (c) {
                    return c instanceof name;
                }) || null;
            } else {
                var ctor = _Ensure2.default.tobeComponentConstructor(name);
                if (!ctor) {
                    throw new Error("component " + name + " is not exist");
                }
                return this.getComponent(ctor);
            }
        }
    }, {
        key: "getComponentsInChildren",
        value: function getComponentsInChildren(name) {
            if (name == null) {
                throw new Error("getComponentsInChildren recieve null or undefined");
            }
            return this.callRecursively(function (node) {
                return node.getComponent(name);
            }).filter(function (c) {
                return !!c;
            });
        }
        /**
         * search component in ancectors of this node.
         * return component that found first.
         * return null if component not found.
         * @param  {[type]} name==null [description]
         * @return {[type]}            [description]
         */

    }, {
        key: "getComponentInAncestor",
        value: function getComponentInAncestor(name) {
            if (name == null) {
                throw new Error("getComponentInAncestor recieve null or undefined");
            }
            if (this.parent) {
                return this.parent._getComponentInAncestor(name);
            }
            return null;
        }
    }, {
        key: "sendInitializedMessage",
        value: function sendInitializedMessage(info) {
            if (this._initializedInfo === info) {
                return;
            }
            var components = this._components.concat(); // copy
            for (var i = 0; i < components.length; i++) {
                components[i].initialized(info);
            }
            this._initializedInfo = info;
            var children = this.children.concat();
            children.forEach(function (child) {
                child.sendInitializedMessage(info);
            });
        }
        /**
         * resolve default attribute value for all component.
         * すべてのコンポーネントの属性をエレメントかデフォルト値で初期化
         */

    }, {
        key: "resolveAttributesValue",
        value: function resolveAttributesValue() {
            this._defaultValueResolved = true;
            var attrs = _NodeUtility2.default.getAttributes(this.element);
            for (var key in attrs) {
                if (key === _Constants2.default.x_gr_id) {
                    continue;
                }
                if (this.isFreezeAttribute(key)) {
                    throw new Error("attribute " + key + " can not change from GOML. Attribute is frozen. ");
                }
            }
            this._components.forEach(function (component) {
                component.resolveDefaultAttributes(attrs);
            });
        }
    }, {
        key: "isFreezeAttribute",
        value: function isFreezeAttribute(attributeName) {
            return !!this.nodeDeclaration.freezeAttributes.toArray().find(function (name) {
                return attributeName === name.fqn;
            });
        }
    }, {
        key: "notifyActivenessUpdate",
        value: function notifyActivenessUpdate(activeness) {
            if (this.isActive !== activeness) {
                this._isActive = activeness;
                this.children.forEach(function (child) {
                    child.notifyActivenessUpdate(activeness && child.enabled);
                });
            }
        }
    }, {
        key: "watch",
        value: function watch(attrName, watcher) {
            var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this._attributeManager.watch(attrName, watcher, immediate);
        }
    }, {
        key: "toString",
        value: function toString() {
            var name = this.name.fqn;
            var id = this.getAttribute("id");
            if (id !== null) {
                name += " id: " + id;
            }
            var classValue = this.getAttribute("class");
            if (classValue !== null) {
                name += " class: " + classValue;
            }
            return name;
        }
        /**
         * Get detailed node structure with highlighting node.
         * @return {string} [description]
         */

    }, {
        key: "toStructualString",
        value: function toStructualString() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            if (this.parent) {
                return "\n" + this.parent._openTreeString() + this._currentSiblingsString(this._layer * 2, "<" + this.toString() + "/>", true, message) + this.parent._closeTreeString();
            } else {
                return "\n" + this._currentSiblingsString(0, "<" + this.toString() + "/>", true, message);
            }
        }
        /**
         * Fetch layer of this node. Root must be 1.
         * @return {number} [description]
         */

    }, {
        key: "_openTreeString",
        value: function _openTreeString() {
            var spaces = "";
            for (var i = 0; i < this._layer * 2; i++) {
                spaces += " ";
            }
            var ancestor = "";
            var abbr = "";
            if (this.parent) {
                ancestor = this.parent._openTreeString();
                if (this.index !== 0) {
                    abbr = spaces + "...\n";
                }
            }
            return "" + ancestor + abbr + spaces + "<" + this.toString() + ">\n";
        }
    }, {
        key: "_closeTreeString",
        value: function _closeTreeString() {
            var spaces = "";
            for (var i = 0; i < this._layer * 2; i++) {
                spaces += " ";
            }
            var ancestor = "";
            var abbr = "";
            if (this.parent) {
                ancestor = this.parent._closeTreeString();
                if (this.index !== this.parent.children.length - 1) {
                    abbr = spaces + "...\n";
                }
            }
            return spaces + "</" + this.name.fqn + ">\n" + abbr + ancestor;
        }
        /**
         * Generate display string for siblings of this node.
         */

    }, {
        key: "_currentSiblingsString",
        value: function _currentSiblingsString(spaceCount, current) {
            var emphasis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

            var spaces = "";
            for (var i = 0; i < spaceCount; i++) {
                spaces += " ";
            }
            var emphasisStr = "";
            if (emphasis) {
                emphasisStr = "" + spaces;
                for (var _i2 = 0; _i2 < current.length; _i2++) {
                    emphasisStr += "^";
                }
            }
            var targets = [];
            if (!this.parent) {
                targets.push("" + spaces + current);
                if (emphasis) {
                    targets.push(emphasisStr + message);
                }
            } else {
                var putDots = false;
                for (var _i3 = 0; _i3 < this.parent.children.length; _i3++) {
                    if (_i3 === this.index) {
                        targets.push("" + spaces + current + "\u30FB\u30FB\u30FB(" + _i3 + ")");
                        if (emphasis) {
                            targets.push(emphasisStr + message);
                        }
                        putDots = false;
                    } else if (_i3 > 0 && this.index - 1 > _i3 || _i3 > this.index + 1 && this.parent.children.length - 1 > _i3) {
                        if (!putDots) {
                            targets.push(spaces + "...");
                            putDots = true;
                        }
                    } else {
                        targets.push(spaces + "<" + this.parent.children[_i3].toString() + "/>\u30FB\u30FB\u30FB(" + _i3 + ")");
                    }
                }
            }
            return targets.join("\n") + "\n";
        }
    }, {
        key: "_sendMessage",
        value: function _sendMessage(message, args) {
            if (this._messageCache[message] === void 0) {
                this._messageCache[message] = this._components.filter(function (c) {
                    return typeof c[message] === "function";
                });
            }
            var targetList = this._messageCache[message];
            for (var i = 0; i < targetList.length; i++) {
                if (targetList[i].disposed) {
                    continue;
                }
                this._sendMessageToComponent(targetList[i], message, args);
            }
        }
    }, {
        key: "_broadcastMessage",
        value: function _broadcastMessage(message, args, range) {
            // message is already ensured.-1 to unlimited range.
            if (!this.isActive) {
                return;
            }
            this._sendMessage(message, args);
            if (range === 0) {
                return;
            }
            var nextRange = range - 1;
            for (var i = 0; i < this.children.length; i++) {
                this.children[i]._broadcastMessage(message, args, nextRange);
            }
        }
    }, {
        key: "_getComponentInAncestor",
        value: function _getComponentInAncestor(name) {
            var ret = this.getComponent(name);
            if (ret) {
                return ret;
            }
            if (this.parent) {
                return this.parent._getComponentInAncestor(name);
            }
            return null;
        }
        /**
         * コンポーネントにメッセージを送る。送信したらバッファからは削除される.
         * @param  {Component} targetComponent 対象コンポーネント
         * @param  {string}    message         メッセージ
         * @param  {boolean}   forced          trueでコンポーネントのenableを無視して送信
         * @param  {boolean}   toBuffer        trueで送信失敗したらバッファに追加
         * @param  {any}       args            [description]
         * @return {boolean}                   送信したか
         */

    }, {
        key: "_sendMessageToComponent",
        value: function _sendMessageToComponent(targetComponent, message, args) {
            if (!targetComponent.enabled) {
                return false;
            }
            var method = targetComponent[message];
            if (typeof method === "function") {
                try {
                    method(args);
                } catch (e) {
                    var wrappedError = new _MessageException2.default(this, targetComponent, message.substr(1), e);
                    this.emit("messageerror", wrappedError);
                    if (!wrappedError.handled) {
                        _GrimoireInterface2.default.emit("messageerror", wrappedError);
                        if (!wrappedError.handled) {
                            throw wrappedError;
                        }
                    }
                }
                return true;
            }
            return false;
        }
    }, {
        key: "_sendMessageForced",
        value: function _sendMessageForced(message) {
            var componentsBuffer = this._components.concat();
            for (var i = 0; i < componentsBuffer.length; i++) {
                var target = componentsBuffer[i];
                if (target.disposed) {
                    continue;
                }
                this._sendMessageForcedTo(target, message);
            }
        }
        /**
         * for system messages.
         * @param {Component} target  [description]
         * @param {string}    message [description]
         */

    }, {
        key: "_sendMessageForcedTo",
        value: function _sendMessageForcedTo(target, message) {
            message = _Ensure2.default.tobeMessage(message);
            var method = target[message];
            if (typeof method === "function") {
                method();
            }
        }
        /**
         * sending mount and awake message if needed to all components.
         */

    }, {
        key: "_mount",
        value: function _mount() {
            this._mounted = true;
            var componentsBuffer = this._components.concat();
            for (var i = 0; i < componentsBuffer.length; i++) {
                var target = componentsBuffer[i];
                if (target.disposed) {
                    continue;
                }
                target.awake();
                this._sendMessageForcedTo(target, "$$mount");
            }
        }
    }, {
        key: "_callRecursively",
        value: function _callRecursively(func, nextGenerator) {
            var val = func(this);
            var nexts = nextGenerator(this);
            var nextVals = nexts.map(function (c) {
                return c.callRecursively(func);
            });
            var list = _Utility2.default.flat(nextVals);
            list.unshift(val);
            return list;
        }
    }, {
        key: "name",

        /**
         * Tag name.
         */
        get: function get() {
            return this.nodeDeclaration.name;
        }
        /**
         * GomlInterface that this node is bound to.
         * throw exception if this node is not mounted.
         * @return {GomlInterface} [description]
         */

    }, {
        key: "tree",
        get: function get() {
            if (!this.mounted) {
                throw new Error("this node is not mounted");
            }
            return this._tree;
        }
        /**
         * indicate this node is already deleted.
         * if this node is deleted once, this node will not be mounted.
         * @return {boolean} [description]
         */

    }, {
        key: "deleted",
        get: function get() {
            return this._deleted;
        }
        /**
         * indicate this node is enabled in tree.
         * This value must be false when ancestor of this node is disabled.
         * @return {boolean} [description]
         */

    }, {
        key: "isActive",
        get: function get() {
            return this._isActive;
        }
        /**
         * indicate this node is enabled.
         * this node never recieve any message if this node is not enabled.
         * @return {boolean} [description]
         */

    }, {
        key: "enabled",
        get: function get() {
            return this._enabled;
        },
        set: function set(value) {
            this.setAttribute("enabled", value);
        }
        /**
         * the shared object by all nodes in tree.
         * @return {NSDictionary<any>} [description]
         */

    }, {
        key: "companion",
        get: function get() {
            return this._companion;
        }
        /**
         * parent node of this node.
         * if this node is root, return null.
         * @return {GomlNode} [description]
         */

    }, {
        key: "parent",
        get: function get() {
            return this._parent;
        }
        /**
         * return true if this node has some child nodes.
         * @return {boolean} [description]
         */

    }, {
        key: "hasChildren",
        get: function get() {
            return this.children.length > 0;
        }
        /**
         * indicate mounted status.
         * this property to be true when treeroot registered to GrimoireInterface.
         * to be false when this node detachd from the tree.
         * @return {boolean} Whether this node is mounted or not.
         */

    }, {
        key: "mounted",
        get: function get() {
            return this._mounted;
        }
    }, {
        key: "index",
        get: function get() {
            if (!this._parent) {
                return -1;
            }
            return this._parent.children.indexOf(this);
        }
    }, {
        key: "_layer",
        get: function get() {
            if (!this.parent) {
                return 1;
            } else {
                return this.parent._layer + 1;
            }
        }
    }], [{
        key: "fromElement",
        value: function fromElement(elem) {
            var id = elem.getAttribute(_Constants2.default.x_gr_id);
            if (id) {
                return _GrimoireInterface2.default.nodeDictionary[id];
            } else {
                throw new Error("element has not 'x-gr-id'");
            }
        }
    }]);

    return GomlNode;
}(_EEObject3.default);

exports.default = GomlNode;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Provides safe xml read feature.
 */
var XMLReader = function () {
    function XMLReader() {
        _classCallCheck(this, XMLReader);
    }

    _createClass(XMLReader, null, [{
        key: "parseXML",
        value: function parseXML(doc, rootElementName) {
            var parsed = XMLReader._parser.parseFromString(doc, "text/xml");
            if (!parsed || parsed.getElementsByTagName("parsererror").length > 0) {
                var err = new XMLSerializer().serializeToString(parsed);
                throw new Error("Error parsing XML: " + err);
            }
            if (rootElementName) {
                if (parsed.documentElement.tagName.toUpperCase() !== rootElementName.toUpperCase()) {
                    throw new Error("Specified document is invalid.");
                } // TODO should throw more detail error
            }
            return [parsed.documentElement]; // TODO: implenent!
        }
    }, {
        key: "getElements",
        value: function getElements(elem, name) {
            var result = [];
            var elems = elem.getElementsByTagName(name);
            for (var i = 0; i < elems.length; i++) {
                result.push(elems.item(i));
            }
            return result;
        }
    }, {
        key: "getSingleElement",
        value: function getSingleElement(elem, name, mandatory) {
            var result = XMLReader.getElements(elem, name);
            if (result.length === 1) {
                return result[0];
            } else if (result.length === 0) {
                if (mandatory) {
                    throw new Error("The mandatory element " + name + " was required, but not found");
                } else {
                    return null;
                }
            } else {
                throw new Error("The element " + name + " requires to exist in single. But there is " + result.length + " count of elements");
            }
        }
    }, {
        key: "getAttribute",
        value: function getAttribute(elem, name, mandatory) {
            var result = elem.attributes.getNamedItem(name);
            if (result) {
                return result.value;
            } else if (mandatory) {
                throw new Error("The mandatory attribute " + name + " was required, but it was not found");
            } else {
                return null;
            }
        }
    }, {
        key: "getAttributeFloat",
        value: function getAttributeFloat(elem, name, mandatory) {
            var resultStr = XMLReader.getAttribute(elem, name, mandatory);
            return resultStr ? parseFloat(resultStr) : null;
        }
    }, {
        key: "getAttributeInt",
        value: function getAttributeInt(elem, name, mandatory) {
            var resultStr = XMLReader.getAttribute(elem, name, mandatory);
            return resultStr ? parseInt(resultStr, 10) : null;
        }
    }, {
        key: "getChildElements",
        value: function getChildElements(elem) {
            var children = elem.childNodes;
            var result = [];
            for (var i = 0; i < children.length; i++) {
                if (children.item(i) instanceof Element) {
                    result.push(children.item(i));
                }
            }
            return result;
        }
    }, {
        key: "getAttributes",
        value: function getAttributes(elem, ns) {
            var result = {};
            var attrs = elem.attributes;
            for (var i = 0; i < attrs.length; i++) {
                var attr = attrs.item(i);
                if (!ns || attr.namespaceURI === ns) {
                    result[attr.localName] = attr.value;
                }
            }
            return result;
        }
    }]);

    return XMLReader;
}();

XMLReader._parser = new DOMParser();
exports.default = XMLReader;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _events = __webpack_require__(37);

var _IDObject2 = __webpack_require__(13);

var _IDObject3 = _interopRequireDefault(_IDObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /// <reference types="node"/>


/**
 * EventEmitterをmixinしたIDObject
 */
var EEObject = function (_IDObject) {
    _inherits(EEObject, _IDObject);

    function EEObject() {
        _classCallCheck(this, EEObject);

        return _possibleConstructorReturn(this, (EEObject.__proto__ || Object.getPrototypeOf(EEObject)).call(this));
    }

    return EEObject;
}(_IDObject3.default);

function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach(function (baseCtor) {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(function (name) {
            derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}
applyMixins(EEObject, [_events.EventEmitter]);
exports.default = EEObject;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Most based object for any Grimoire.js related classes.
 * @type {[type]}
 */
var IDObject = function () {
    _createClass(IDObject, null, [{
        key: "getUniqueRandom",

        /**
         * Generate random string
         * @param  {number} length length of random string
         * @return {string}        generated string
         */
        value: function getUniqueRandom(length) {
            return Math.random().toString(36).slice(-length);
        }
    }]);

    function IDObject() {
        _classCallCheck(this, IDObject);

        this.id = IDObject.getUniqueRandom(10);
    }
    /**
     * Obtain stringfied object.
     * If this method was not overridden, this method return class name.
     * @return {string} stringfied object
     */


    _createClass(IDObject, [{
        key: "toString",
        value: function toString() {
            return this.getTypeName();
        }
        /**
         * Obtain class name
         * @return {string} Class name of the instance.
         */

    }, {
        key: "getTypeName",
        value: function getTypeName() {
            var funcNameRegex = /function (.{1,})\(/;
            var result = funcNameRegex.exec(this.constructor.toString());
            return result && result.length > 1 ? result[1] : "";
        }
    }]);

    return IDObject;
}();

exports.default = IDObject;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

var _GomlParser = __webpack_require__(9);

var _GomlParser2 = _interopRequireDefault(_GomlParser);

var _XMLReader = __webpack_require__(11);

var _XMLReader2 = _interopRequireDefault(_XMLReader);

var _XMLHttpRequestAsync = __webpack_require__(23);

var _XMLHttpRequestAsync2 = _interopRequireDefault(_XMLHttpRequestAsync);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

/**
 * Provides the features to fetch Goml source.
 */
var GomlLoader = function () {
    function GomlLoader() {
        _classCallCheck(this, GomlLoader);
    }

    _createClass(GomlLoader, null, [{
        key: "loadFromScriptTag",

        /**
         * Obtain the Goml source from specified tag.
         * @param  {HTMLScriptElement} scriptTag [the script tag to load]
         * @return {Promise<void>}               [the promise to wait for loading]
         */
        value: function loadFromScriptTag(scriptTag) {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                var srcAttr, source, req, doc, rootNode;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                srcAttr = scriptTag.getAttribute("src");
                                source = void 0;

                                if (!srcAttr) {
                                    _context.next = 10;
                                    break;
                                }

                                // ignore text element
                                req = new XMLHttpRequest();

                                req.open("GET", srcAttr);
                                _context.next = 7;
                                return _XMLHttpRequestAsync2.default.send(req);

                            case 7:
                                source = req.responseText;
                                _context.next = 11;
                                break;

                            case 10:
                                source = scriptTag.text;

                            case 11:
                                doc = _XMLReader2.default.parseXML(source, "GOML");
                                rootNode = _GomlParser2.default.parse(doc[0]);

                                _GrimoireInterface2.default.addRootNode(scriptTag, rootNode);

                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
        /**
         * Load from the script tags which will be found with specified query.
         * @param  {string}          query [the query to find script tag]
         * @return {Promise<void[]>}       [the promise to wait for all goml loading]
         */

    }, {
        key: "loadFromQuery",
        value: function loadFromQuery(query) {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
                var tags, pArray, elements, i, element;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                tags = document.querySelectorAll(query);
                                pArray = [];
                                elements = [];

                                for (i = 0; i < tags.length; i++) {
                                    element = tags.item(i);

                                    elements.push(element);
                                    pArray[i] = GomlLoader.loadFromScriptTag(element);
                                }
                                if (pArray.length === 0 && _GrimoireInterface2.default.debug) {
                                    console.warn("There was no goml file detected. Have you specified `type='text/goml'` to the script tag?");
                                }
                                _context2.next = 7;
                                return Promise.all(pArray);

                            case 7:
                                GomlLoader.initializedEventHandlers.forEach(function (handler) {
                                    handler(elements);
                                });

                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));
        }
        /**
         * Load all Goml sources contained in HTML.
         * @return {Promise<void>} [the promise to wait for all goml loading]
         */

    }, {
        key: "loadForPage",
        value: function loadForPage() {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return GomlLoader.loadFromQuery('script[type="text/goml"]');

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));
        }
    }]);

    return GomlLoader;
}();

GomlLoader.initializedEventHandlers = [];
exports.default = GomlLoader;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NodeUtility = function () {
    function NodeUtility() {
        _classCallCheck(this, NodeUtility);
    }

    _createClass(NodeUtility, null, [{
        key: "getNodeListIndexByElementIndex",

        /**
         * Get index of NodeList converted from index in Element
         * @param  {HTMLElement} targetElement Parent element of search target elements
         * @param  {number}      elementIndex  Index in element
         * @return {number}                    Index in NodeList
         */
        value: function getNodeListIndexByElementIndex(targetElement, elementIndex) {
            var nodeArray = Array.prototype.slice.call(targetElement.childNodes);
            var elementArray = nodeArray.filter(function (v) {
                return v.nodeType === 1;
            });
            elementIndex = elementIndex < 0 ? elementArray.length + elementIndex : elementIndex;
            return nodeArray.indexOf(elementArray[elementIndex]);
        }
    }, {
        key: "getAttributes",
        value: function getAttributes(element) {
            var attributes = {};
            var domAttr = element.attributes;
            for (var i = 0; i < domAttr.length; i++) {
                var attrNode = domAttr.item(i);
                if (attrNode.name.startsWith("xmlns")) {
                    continue;
                }
                var name = attrNode.namespaceURI ? attrNode.namespaceURI + "." + attrNode.localName : attrNode.localName;
                attributes[name] = attrNode.value;
            }
            return attributes;
        }
    }]);

    return NodeUtility;
}();

exports.default = NodeUtility;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Constants = __webpack_require__(5);

var _Constants2 = _interopRequireDefault(_Constants);

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

var _Attribute = __webpack_require__(17);

var _Attribute2 = _interopRequireDefault(_Attribute);

var _NSDictionary = __webpack_require__(6);

var _NSDictionary2 = _interopRequireDefault(_NSDictionary);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _IdResolver = __webpack_require__(4);

var _IdResolver2 = _interopRequireDefault(_IdResolver);

var _Component = __webpack_require__(8);

var _Component2 = _interopRequireDefault(_Component);

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComponentDeclaration = function () {
    function ComponentDeclaration(name, _ctorOrObj, _super) {
        _classCallCheck(this, ComponentDeclaration);

        this.name = name;
        this._ctorOrObj = _ctorOrObj;
        this.idResolver = new _IdResolver2.default();
        this._resolvedDependency = false;
        if (!_super) {
            this.resolveDependency();
            return;
        }
        if (_super instanceof _NSIdentity2.default || typeof _super === "string") {
            this._super = _super;
        } else {
            this.superComponent = _super;
        }
    }

    _createClass(ComponentDeclaration, [{
        key: "generateInstance",
        value: function generateInstance(componentElement) {
            if (!this.isDependenyResolved) {
                this.resolveDependency();
            }
            componentElement = componentElement ? componentElement : document.createElementNS(this.name.ns.qualifiedName, this.name.name);
            var component = new this.ctor();
            componentElement.setAttribute(_Constants2.default.x_gr_id, component.id);
            _GrimoireInterface2.default.componentDictionary[component.id] = component;
            component.name = this.name;
            component.element = componentElement;
            component.attributes = new _NSDictionary2.default();
            for (var key in this.attributes) {
                _Attribute2.default.generateAttributeForComponent(key, this.attributes[key], component);
            }
            return component;
        }
    }, {
        key: "resolveDependency",
        value: function resolveDependency() {
            if (this._resolvedDependency) {
                return false;
            }
            var attr = {};
            var dec = void 0;
            if (this._super || this.superComponent) {
                var id = this._super ? _Ensure2.default.tobeNSIdentity(this._super) : this.superComponent["name"];
                dec = _GrimoireInterface2.default.componentDeclarations.get(id);
                dec.resolveDependency();
                for (var key in dec.attributes) {
                    attr[key] = dec.attributes[key];
                    this.idResolver.add(_NSIdentity2.default.fromFQN(this.name.fqn + "." + key));
                }
                this.superComponent = dec.ctor;
            }
            this.ctor = this._ensureTobeComponentConstructor(this.name, this._ctorOrObj, dec ? dec.ctor : void 0);
            for (var _key in this.ctor.attributes) {
                attr[_key] = this.ctor.attributes[_key];
                this.idResolver.add(_NSIdentity2.default.fromFQN(this.name.fqn + "." + _key));
            }
            this.attributes = attr;
            ComponentDeclaration.ctorMap.push({ ctor: this._ctorOrObj, name: this.name });
            return this._resolvedDependency = true;
        }
        /**
         * Ensure the given object or constructor to be an constructor inherits Component;
         * @param  {Object | (new ()=> Component} obj [The variable need to be ensured.]
         * @return {[type]}      [The constructor inherits Component]
         */

    }, {
        key: "_ensureTobeComponentConstructor",
        value: function _ensureTobeComponentConstructor(id, obj, baseConstructor) {
            if (typeof obj === "function") {
                var inheritsAttr = this._extractInheritsAttributes(obj);
                if (baseConstructor) {
                    var newCtor = function newCtor() {
                        baseConstructor.call(this);
                        obj.call(this);
                    };
                    var proto = this._clonePrototypeChain(obj.prototype, baseConstructor.prototype);
                    newCtor.prototype = proto;
                    newCtor.prototype["name"] = id;
                    newCtor.attributes = inheritsAttr;
                    return newCtor;
                } else {
                    obj.prototype["name"] = id;
                    obj.attributes = inheritsAttr;
                    return obj;
                }
            } else {
                if (baseConstructor && !(baseConstructor.prototype instanceof _Component2.default) && baseConstructor !== _Component2.default) {
                    throw new Error("Base component comstructor must extends Compoent class.");
                }
                var ctor = baseConstructor || _Component2.default;
                var _newCtor = function _newCtor() {
                    ctor.call(this);
                };
                obj.__proto__ = ctor.prototype;
                _newCtor.prototype = obj;
                _newCtor.attributes = obj.attributes;
                _newCtor.prototype["name"] = id;
                return _newCtor;
            }
        }
    }, {
        key: "_extractInheritsAttributes",
        value: function _extractInheritsAttributes(ctor) {
            var attrs = [];
            while (ctor) {
                if (ctor === _Component2.default) {
                    break;
                }
                attrs.push(ctor.attributes);
                ctor = ctor.prototype.__proto__.constructor;
            }
            var atr = {};
            for (var i = attrs.length - 1; i >= 0; i--) {
                for (var key in attrs[i]) {
                    atr[key] = attrs[i][key];
                }
            }
            return atr;
        }
    }, {
        key: "_clonePrototypeChain",
        value: function _clonePrototypeChain(obj, base) {
            var chain = [];
            var c = obj;
            while (true) {
                if (c.constructor === _Component2.default) {
                    break;
                }
                chain.push(c);
                c = Object.getPrototypeOf(c);
            }
            chain.reverse();
            chain.pop();
            var ret = base;
            for (var i = 0; i < chain.length; i++) {
                var props = Object.getOwnPropertyDescriptors(chain[0]);
                ret = Object.create(ret, props);
            }
            obj.__proto__ = ret;
            return obj;
        }
    }, {
        key: "isDependenyResolved",
        get: function get() {
            return this._resolvedDependency;
        }
    }]);

    return ComponentDeclaration;
}();

exports.default = ComponentDeclaration;

ComponentDeclaration.ctorMap = [];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _IdResolver = __webpack_require__(4);

var _IdResolver2 = _interopRequireDefault(_IdResolver);

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Manage a attribute attached to components.
 */
var Attribute = function () {
    function Attribute() {
        _classCallCheck(this, Attribute);

        this.convertContext = {};
        /**
         * List of functions that is listening changing values.
         */
        this._observers = [];
        this._ignoireActivenessObservers = [];
    }
    /**
     * Goml tree interface which contains the component this attribute bound to.
     * @return {GomlInterface} [description]
     */


    _createClass(Attribute, [{
        key: "watch",

        /**
         * Add event handler to observe changing this attribute.
         * @param  {(attr: Attribute) => void} handler handler the handler you want to add.
         * @param {boolean = false} callFirst whether that handler should be called first time.
         */
        value: function watch(watcher) {
            var immedateCalls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var ignoireActiveness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (ignoireActiveness) {
                this._ignoireActivenessObservers.push(watcher);
            } else {
                this._observers.push(watcher);
            }
            if (immedateCalls) {
                watcher(this.Value, void 0, this);
            }
        }
        /**
         * Remove event handler you added.
         * @param  {Attribute} handler [description]
         * @return {[type]}            [description]
         */

    }, {
        key: "unwatch",
        value: function unwatch(target) {
            var index = this._observers.findIndex(function (f) {
                return f === target;
            });
            if (index >= 0) {
                this._observers.splice(index, 1);
                return;
            }
            index = this._ignoireActivenessObservers.findIndex(function (f) {
                return f === target;
            });
            if (index >= 0) {
                this._ignoireActivenessObservers.splice(index, 1);
                return;
            }
        }
        /**
         * Bind converted value to specified field.
         * When target object was not specified, field of owner component would be assigned.
         * @param {string} variableName [description]
         * @param {any} targetObject [description]
         */

    }, {
        key: "boundTo",
        value: function boundTo(variableName) {
            var _this = this;

            var targetObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.component;

            if (targetObject[variableName]) {
                console.warn("component field " + variableName + " is already defined.");
            }
            if (this.converter["lazy"]) {
                Object.defineProperty(targetObject, variableName, {
                    get: function get() {
                        return _this.Value;
                    },
                    set: function set(val) {
                        _this.Value = val;
                    },
                    enumerable: true,
                    configurable: true
                });
            } else {
                var backing = void 0;
                this.watch(function (v) {
                    backing = v;
                }, true);
                Object.defineProperty(targetObject, variableName, {
                    get: function get() {
                        return backing;
                    },
                    set: function set(val) {
                        _this.Value = val;
                    },
                    enumerable: true,
                    configurable: true
                });
            }
        }
        /**
         * Apply default value to attribute from DOM values.
         * @param {string }} domValues [description]
         */

    }, {
        key: "resolveDefaultValue",
        value: function resolveDefaultValue(domValues) {
            if (this._value !== void 0) {
                return;
            }
            // resolve by goml value
            var resolver = new _IdResolver2.default();
            resolver.add(this.name);
            var tagAttrKey = void 0;
            for (var key in domValues) {
                if (_Ensure2.default.checkFQNString(key)) {
                    if (this.name.fqn === key.substring(1)) {
                        this.Value = domValues[key];
                        return;
                    }
                    continue;
                }
                var get = resolver.get(key);
                if (get.length > 0) {
                    if (tagAttrKey === void 0) {
                        tagAttrKey = key;
                    } else {
                        throw new Error("tag attribute is ambiguous for " + this.name.fqn + ". It has the following possibilities " + tagAttrKey + " " + get[0]);
                    }
                }
            }
            if (tagAttrKey !== void 0) {
                this.Value = domValues[tagAttrKey];
                return;
            }
            // resolve by node defaults.
            var nodeDefaultValue = this.component.node.nodeDeclaration.defaultAttributesActual.hasMatchingValue(this.name);
            if (nodeDefaultValue !== void 0) {
                this.Value = nodeDefaultValue; // Node指定値で解決
                return;
            }
            // resolve by component defaults.
            this.Value = this.declaration.default;
        }
    }, {
        key: "_valuate",
        value: function _valuate(raw) {
            var v = this.converter.convert(raw, this);
            if (v === void 0) {
                var errorMessage = "Converting attribute value failed.\n\n* input : " + raw + "\n* Attribute(Attribute FQN) : " + this.name.name + "(" + this.name.fqn + ")\n* Component : " + this.component.name.name + "(" + this.component.name.fqn + ")\n* Node(Node FQN) : " + this.component.node.name.name + "(" + this.component.node.name.fqn + ")\n* Converter : " + this.declaration.converter + "\n\n* Structure map:\n" + this.component.node.toStructualString("--------------Error was thrown from '" + this.name.name + "' of this node.");
                throw new Error(errorMessage);
            }
            this._lastValuete = v;
            return v;
        }
    }, {
        key: "_notifyChange",
        value: function _notifyChange(newValue) {
            var _this2 = this;

            var lastvalue = this._lastValuete;
            if (!this.component.isActive) {
                if (this._ignoireActivenessObservers.length === 0) {
                    return;
                }
                var convertedNewValue = this._valuate(newValue);
                this._ignoireActivenessObservers.forEach(function (watcher) {
                    watcher(convertedNewValue, lastvalue, _this2);
                });
            } else {
                var _convertedNewValue = this._valuate(newValue);
                this._observers.forEach(function (watcher) {
                    watcher(_convertedNewValue, lastvalue, _this2);
                });
                this._ignoireActivenessObservers.forEach(function (watcher) {
                    watcher(_convertedNewValue, lastvalue, _this2);
                });
            }
        }
    }, {
        key: "tree",
        get: function get() {
            return this.component.tree;
        }
        /**
         * Companion map which is bounding to the component this attribute bound to.
         * @return {NSDictionary<any>} [description]
         */

    }, {
        key: "companion",
        get: function get() {
            return this.component.companion;
        }
        /**
         * Get a value with specified type.
         * @return {any} value with specified type.
         */

    }, {
        key: "Value",
        get: function get() {
            if (this._value === void 0) {
                var node = this.component.node;
                throw new Error("attribute " + this.name.name + " value is undefined in " + (node ? node.name.name : "undefined"));
            }
            return this._valuate(this._value);
        }
        /**
         * Set a value with any type.
         * @param {any} val Value with string or specified type.
         */
        ,
        set: function set(val) {
            if (this._value === val) {
                return;
            }
            this._value = val;
            this._notifyChange(val);
        }
    }], [{
        key: "convert",
        value: function convert(converter, self, val) {
            var cname = _Ensure2.default.tobeNSIdentity(converter);
            var conv = _GrimoireInterface2.default.converters.get(cname);
            if (!conv) {
                throw new Error("converter " + cname.name + " is not defined.");
            }
            return conv.convert(val, self);
        }
        /**
         * Construct a new attribute with name of key and any value with specified type. If constant flag is true, This attribute will be immutable.
         * If converter is not served, string converter will be set as default.
         * @param {string}        key       Key of this attribute.
         * @param {any}           value     Value of this attribute.
         * @param {ConverterBase} converter Converter of this attribute.
         * @param {boolean}       constant  Whether this attribute is immutable or not. False as default.
         */

    }, {
        key: "generateAttributeForComponent",
        value: function generateAttributeForComponent(name, declaration, component) {
            var attr = new Attribute();
            attr.name = _NSIdentity2.default.fromFQN(component.name.fqn + "." + name);
            attr.component = component;
            attr.declaration = declaration;
            var converterName = _Ensure2.default.tobeNSIdentity(declaration.converter);
            attr.converter = _GrimoireInterface2.default.converters.get(converterName);
            if (attr.converter === void 0) {
                // When the specified converter was not found
                throw new Error("Specified converter " + converterName.name + " was not found from registered converters.\n Component: " + attr.component.name.fqn + "\n Attribute: " + attr.name.name);
            }
            attr.component.attributes.set(attr.name, attr);
            attr.converter.verify(attr);
            return attr;
        }
    }]);

    return Attribute;
}();

exports.default = Attribute;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utility = __webpack_require__(3);

var _Utility2 = _interopRequireDefault(_Utility);

var _XMLReader = __webpack_require__(11);

var _XMLReader2 = _interopRequireDefault(_XMLReader);

var _GomlParser = __webpack_require__(9);

var _GomlParser2 = _interopRequireDefault(_GomlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * interface for operate multicast nodes.
 */
var NodeInterface = function () {
    function NodeInterface(nodes) {
        _classCallCheck(this, NodeInterface);

        if (!nodes) {
            throw new Error("nodes is null");
        }
        this.nodes = nodes;
    }
    /**
     * get count of targeted nodes.
     * @return {number} [description]
     */


    _createClass(NodeInterface, [{
        key: "get",
        value: function get(i1, i2) {
            if (i1 === void 0) {
                var first = this.first();
                if (!first) {
                    throw new Error("this NodeInterface is empty.");
                } else {
                    return first;
                }
            } else if (i2 === void 0) {
                if (this.count <= i1) {
                    throw new Error("index out of range.");
                }
                var c = i1;
                return this.find(function () {
                    if (c === 0) {
                        return true;
                    }
                    c--;
                    return false;
                });
            } else {
                if (this.nodes.length <= i1 || this.nodes[i1].length <= i2) {
                    throw new Error("index out of range.");
                } else {
                    return this.nodes[i1][i2];
                }
            }
        }
    }, {
        key: "getAttribute",
        value: function getAttribute(attrName) {
            var first = this.first();
            if (!first) {
                throw new Error("this NodeInterface is empty.");
            }
            return first.getAttribute(attrName);
        }
    }, {
        key: "setAttribute",
        value: function setAttribute(attrName, value) {
            this.forEach(function (node) {
                node.setAttribute(attrName, value, false);
            });
        }
        /**
         * 対象ノードにイベントリスナを追加します。
         * @param {string}   eventName [description]
         * @param {Function} listener  [description]
         */

    }, {
        key: "on",
        value: function on(eventName, listener) {
            this.forEach(function (node) {
                node.on(eventName, listener);
            });
            return this;
        }
        /**
         * 対象ノードに指定したイベントリスナが登録されていれば削除します
         * @param {string}   eventName [description]
         * @param {Function} listener  [description]
         */

    }, {
        key: "off",
        value: function off(eventName, listener) {
            this.forEach(function (node) {
                node.removeListener(eventName, listener);
            });
            return this;
        }
        /**
         * このノードインタフェースが対象とするノードそれぞれに、
         * タグで指定したノードを子要素として追加します。
         * @param {string} tag [description]
         */

    }, {
        key: "append",
        value: function append(tag) {
            this.forEach(function (node) {
                var elems = _XMLReader2.default.parseXML(tag);
                elems.forEach(function (elem) {
                    var child = _GomlParser2.default.parse(elem);
                    node.addChild(child);
                });
            });
            return this;
        }
        /**
         * このノードインタフェースが対象とするノードをツリーから削除します。s
         * @param {GomlNode} child [description]
         */

    }, {
        key: "remove",
        value: function remove() {
            this.forEach(function (node) {
                node.remove();
            });
            return this;
        }
        /**
         * execute provided function once for each element targeted by this interface.
         * @param  {number} callback Function to execute for each element, taking three arguments:
         * abort the iteration if function returns True.
         * @return {[type]}          [description]
         */

    }, {
        key: "forEach",
        value: function forEach(callback) {
            for (var i = 0; i < this.nodes.length; i++) {
                var array = this.nodes[i];
                var gomlIndex = i;
                for (var j = 0; j < array.length; j++) {
                    var node = array[j];
                    var nodeIndex = j;
                    var ih = { abort: false };
                    callback(node, gomlIndex, nodeIndex, ih);
                    if (ih.abort) {
                        return this;
                    }
                }
            }
            return this;
        }
    }, {
        key: "map",
        value: function map(func) {
            return this.nodes.map(function (array, gomlIndex) {
                return array.map(function (node, nodeIndex) {
                    return func(node, gomlIndex, nodeIndex);
                });
            });
        }
    }, {
        key: "find",
        value: function find(predicate) {
            var nodes = this.nodes;
            for (var i = 0; i < nodes.length; i++) {
                var array = nodes[i];
                for (var j = 0; j < array.length; j++) {
                    var node = array[j];
                    if (predicate(node, i, j)) {
                        return node;
                    }
                }
            }
            return null;
        }
    }, {
        key: "watch",
        value: function watch(attrName, watcher) {
            var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.forEach(function (node) {
                node.watch(attrName, watcher, immediate);
            });
        }
        /**
         * このノードインタフェースが対象とするノードを有効、または無効にします。
         * @param {boolean} enable [description]
         */

    }, {
        key: "setEnable",
        value: function setEnable(enable) {
            this.forEach(function (node) {
                node.enabled = !!enable;
            });
            return this;
        }
        /**
         * このノードインタフェースが対象とするノードのそれぞれの子ノードを対象とする、
         * 新しいノードインタフェースを取得します。
         * @return {NodeInterface} [description]
         */

    }, {
        key: "children",
        value: function children() {
            var children = this.nodes.map(function (nodes) {
                return _Utility2.default.flatMap(nodes, function (node) {
                    return node.children;
                });
            });
            return new NodeInterface(children);
        }
        /**
         * 対象ノードにコンポーネントをアタッチします。
         * @param {Component} component [description]
         */

    }, {
        key: "addComponent",
        value: function addComponent(componentId) {
            var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.forEach(function (node) {
                node.addComponent(componentId, attributes);
            });
            return this;
        }
        /**
         * 最初の対象ノードを取得する
         * ひとつもなければnull
         * @return {GomlNode} [description]
         */

    }, {
        key: "first",
        value: function first() {
            return this.find(function () {
                return true;
            });
        }
        /**
         * 対象となる唯一のノードを取得する。
         * 対象が存在しない、あるいは複数存在するときは例外を投げる。
         * @return {GomlNode} [description]
         */

    }, {
        key: "single",
        value: function single() {
            if (this.count !== 1) {
                throw new Error("this nodeInterface is not single.");
            }
            var first = this.first();
            if (!first) {
                throw new Error("this nodeInterface is not single,but is empty.");
            }
            return first;
        }
    }, {
        key: "filter",
        value: function filter(predicate) {
            var newNodes = [];
            for (var i = 0; i < this.nodes.length; i++) {
                var goml = this.nodes[i];
                newNodes.push([]);
                for (var j = 0; j < goml.length; j++) {
                    var node = goml[j];
                    if (predicate(node, i, j)) {
                        newNodes[i].push(node);
                    }
                }
            }
            return new NodeInterface(newNodes);
        }
    }, {
        key: "toArray",
        value: function toArray() {
            return _Utility2.default.flat(this.nodes);
        }
    }, {
        key: "addChildByName",
        value: function addChildByName(nodeName, attributes) {
            return new NodeInterface(this.map(function (node) {
                return node.addChildByName(nodeName, attributes);
            }));
        }
    }, {
        key: "sendMessage",
        value: function sendMessage(message, args) {
            this.forEach(function (node) {
                node.sendMessage(message, args);
            });
        }
    }, {
        key: "broadcastMessage",
        value: function broadcastMessage(arg1, arg2, arg3) {
            if (typeof arg1 === "number") {
                this.forEach(function (node) {
                    node.broadcastMessage(arg1, arg2, arg3);
                });
            } else {
                this.forEach(function (node) {
                    node.broadcastMessage(arg2, arg3);
                });
            }
        }
    }, {
        key: "count",
        get: function get() {
            if (this.nodes.length === 0) {
                return 0;
            }
            var counts = this.nodes.map(function (nodes) {
                return nodes.length;
            });
            return _Utility2.default.sum(counts);
        }
    }, {
        key: "isEmpty",
        get: function get() {
            return this.count === 0;
        }
    }]);

    return NodeInterface;
}();

exports.default = NodeInterface;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Constants = __webpack_require__(5);

var _Constants2 = _interopRequireDefault(_Constants);

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

var _NodeInterface = __webpack_require__(18);

var _NodeInterface2 = _interopRequireDefault(_NodeInterface);

var _GomlNode = __webpack_require__(10);

var _GomlNode2 = _interopRequireDefault(_GomlNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Provides interfaces to treat whole goml tree for each.
 */
var GomlInterface = function () {
    function GomlInterface(rootNodes) {
        _classCallCheck(this, GomlInterface);

        this.rootNodes = rootNodes;
    }

    _createClass(GomlInterface, [{
        key: "getNodeById",
        value: function getNodeById(id) {
            return this.rootNodes.map(function (root) {
                return _GomlNode2.default.fromElement(root.element.ownerDocument.getElementById(id));
            });
        }
    }, {
        key: "queryFunc",
        value: function queryFunc(query) {
            return new _NodeInterface2.default(this._queryNodes(query));
        }
    }, {
        key: "_queryNodes",
        value: function _queryNodes(query) {
            return this.rootNodes.map(function (root) {
                var nodelist = root.element.ownerDocument.querySelectorAll(query);
                var nodes = [];
                for (var i = 0; i < nodelist.length; i++) {
                    var id = nodelist.item(i).getAttribute(_Constants2.default.x_gr_id);
                    if (id) {
                        var node = _GrimoireInterface2.default.nodeDictionary[id];
                        if (node) {
                            nodes.push(node);
                        }
                    }
                }
                return nodes;
            });
        }
    }]);

    return GomlInterface;
}();

exports.default = GomlInterface;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utility = __webpack_require__(3);

var _Utility2 = _interopRequireDefault(_Utility);

var _IdResolver = __webpack_require__(4);

var _IdResolver2 = _interopRequireDefault(_IdResolver);

var _Namespace = __webpack_require__(7);

var _Namespace2 = _interopRequireDefault(_Namespace);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AttributeBuffer = function () {
    function AttributeBuffer() {
        _classCallCheck(this, AttributeBuffer);

        this._fqnList = [];
    }

    _createClass(AttributeBuffer, [{
        key: "add",
        value: function add(fqn, val) {
            for (var i = 0; i < this._fqnList.length; i++) {
                var c = this._fqnList[i];
                if (c.fqn === fqn) {
                    c.val = val;
                    this._fqnList.splice(i, 1);
                    this._fqnList.push(c);
                    return;
                }
            }
            var obj = { fqn: fqn, val: val };
            this._fqnList.push(obj);
        }
    }, {
        key: "resolve",
        value: function resolve(fqn, remove) {
            var guess = this.guess(fqn, remove);
            return guess.length === 0 ? void 0 : guess[guess.length - 1];
        }
        /**
         * get list of value that matchs given fqn.
         * @param  {string}         fqn          [description]
         * @param  {[type]}         remove=false to remove match buffers.
         * @return {NameValPair<T>}              [description]
         */

    }, {
        key: "guess",
        value: function guess(fqn, remove) {
            var resolver = new _IdResolver2.default();
            resolver.add(fqn.split("."));
            var ret = [];
            for (var i = 0; i < this._fqnList.length; i++) {
                var name = this._fqnList[i].fqn;
                var r = resolver.get(name);
                if (r.length > 0) {
                    ret.push(this._fqnList[i].val);
                    if (remove) {
                        this._fqnList.splice(i, 1);
                        i--;
                    }
                }
            }
            return ret;
        }
    }]);

    return AttributeBuffer;
}();
/**
 * internal use!
 * @return {[type]} [description]
 */


var AttributeManager = function () {
    function AttributeManager(tag) {
        _classCallCheck(this, AttributeManager);

        this.tag = tag;
        this._attributesFQNMap = {};
        this._idResolver = new _IdResolver2.default();
        this._attrBuffer = new AttributeBuffer();
        this._watchBuffer = new AttributeBuffer();
    }

    _createClass(AttributeManager, [{
        key: "addAttribute",
        value: function addAttribute(attr) {
            var fqn = attr.name.fqn;
            if (this._idResolver.has(fqn)) {
                _Utility2.default.w("attribute " + attr.name + " is already exist in " + this.tag);
            }
            if (this._attributesFQNMap[fqn] === void 0) {
                this._attributesFQNMap[fqn] = [];
            }
            this._attributesFQNMap[fqn].push(attr);
            this._idResolver.add(attr.name);
            // check buffer value.
            var attrBuf = this._attrBuffer.resolve(attr.name.fqn, true);
            if (attrBuf !== void 0) {
                attr.Value = attrBuf;
            }
            var watchBuf = this._watchBuffer.guess(attr.name.fqn, true);
            for (var i = 0; i < watchBuf.length; i++) {
                attr.watch(watchBuf[i], true);
            }
            return attr;
        }
    }, {
        key: "watch",
        value: function watch(attrName, watcher) {
            var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var fqn = _Ensure2.default.tobeFQN(attrName);
            if (fqn) {
                var attrs = this._attributesFQNMap[fqn];
                if (attrs === void 0 || attrs.length === 0) {
                    this._watchBuffer.add(fqn, watcher);
                    return;
                }
                for (var i = 0; i < attrs.length; i++) {
                    attrs[i].watch(watcher, immediate);
                }
            } else {
                attrName = attrName;
                var res = this._idResolver.get(_Namespace2.default.defineByArray(attrName.split(".")));
                if (res.length === 0) {
                    this._watchBuffer.add(attrName, watcher);
                    return;
                }
                if (res.length > 1) {
                    throw new Error("attribute " + attrName + " is ambiguous");
                }
                for (var _i = 0; _i < this._attributesFQNMap[res[0]].length; _i++) {
                    this._attributesFQNMap[res[0]][_i].watch(watcher, immediate);
                }
            }
        }
    }, {
        key: "setAttribute",
        value: function setAttribute(attrFQN, value) {
            var attrs = this._attributesFQNMap[attrFQN];
            if (attrs === void 0 || attrs.length === 0) {
                this._attrBuffer.add(attrFQN, value);
                return;
            }
            for (var i = 0; i < attrs.length; i++) {
                attrs[i].Value = value;
            }
        }
        /**
         * 文字列指定は曖昧性解消する。
         * 曖昧はエラー。存在しないのはエラー。
         * NSIdentityはfqnで。
         * 指定されたFQNの属性が複数の場合エラー。
         * @param  {Name}      attrName [description]
         * @return {Attribute}          [description]
         */

    }, {
        key: "getAttributeRaw",
        value: function getAttributeRaw(attrName) {
            var fqn = _Ensure2.default.tobeFQN(attrName);
            if (fqn) {
                var attrs = this._attributesFQNMap[fqn] || [];
                if (attrs.length === 0) {
                    throw new Error("attribute " + fqn + " is not found.");
                } else if (attrs.length !== 1) {
                    throw new Error("attribute " + fqn + " is ambiguous. there are " + attrs.length + " attributes has same fqn.");
                }
                return attrs[0];
            } else {
                attrName = attrName;
                var res = this._idResolver.get(attrName);
                if (res.length === 0) {
                    throw new Error("attribute " + attrName + " is not found.");
                }
                if (res.length > 1) {
                    throw new Error("attribute " + attrName + " is ambiguous. It has the following possibilities. " + res);
                }
                if (this._attributesFQNMap[res[0]].length !== 1) {
                    throw new Error("attribute " + attrName + " is ambiguous. there are " + this._attributesFQNMap[res[0]].length + " attributes has same fqn.");
                }
                return this._attributesFQNMap[res[0]][0];
            }
        }
    }, {
        key: "getAttribute",
        value: function getAttribute(attrName) {
            var fqn = _Ensure2.default.tobeFQN(attrName);
            if (fqn) {
                var attrs = this._attributesFQNMap[fqn] || [];
                if (attrs.length === 0) {
                    var attrBuf = this._attrBuffer.resolve(fqn, false);
                    if (attrBuf !== void 0) {
                        return attrBuf;
                    }
                    throw new Error("attribute " + attrName + " is not found.");
                } else if (attrs.length !== 1) {
                    throw new Error("attribute " + attrName + " is ambiguous. there are " + attrs.length + " attributes has same fqn.");
                }
                return attrs[0].Value;
            } else {
                attrName = attrName;
                var res = this._idResolver.get(attrName);
                if (res.length === 0) {
                    var _attrBuf = this._attrBuffer.resolve(attrName, false);
                    if (_attrBuf !== void 0) {
                        return _attrBuf;
                    }
                    throw new Error("attribute " + attrName + " is not found.");
                }
                if (res.length > 1) {
                    throw new Error("attribute " + attrName + " is ambiguous. there are " + this._attributesFQNMap[res[0]].length + " attributes has same fqn.");
                }
                return this._attributesFQNMap[res[0]][0].Value;
            }
        }
    }, {
        key: "removeAttribute",
        value: function removeAttribute(attr) {
            if (this._attributesFQNMap[attr.name.fqn]) {
                var attributes = this._attributesFQNMap[attr.name.fqn];
                if (attributes.length === 1) {
                    this._idResolver.remove(attr.name);
                }
                _Utility2.default.remove(attributes, attr);
                delete this._attributesFQNMap[attr.name.fqn];
                return true;
            }
            return false;
        }
    }, {
        key: "guess",
        value: function guess(name) {
            if (name instanceof _NSIdentity2.default) {
                return [name];
            }
            if (_Ensure2.default.checkFQNString(name)) {
                return [_NSIdentity2.default.fromFQN(name)];
            }
            return this._idResolver.get(name).map(function (fqn) {
                return _NSIdentity2.default.fromFQN(fqn);
            });
        }
    }]);

    return AttributeManager;
}();

exports.default = AttributeManager;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EEObject2 = __webpack_require__(12);

var _EEObject3 = _interopRequireDefault(_EEObject2);

var _GomlLoader = __webpack_require__(14);

var _GomlLoader2 = _interopRequireDefault(_GomlLoader);

var _EnumConverter = __webpack_require__(24);

var _EnumConverter2 = _interopRequireDefault(_EnumConverter);

var _NumberArrayConverter = __webpack_require__(25);

var _NumberArrayConverter2 = _interopRequireDefault(_NumberArrayConverter);

var _ComponentConverter = __webpack_require__(26);

var _ComponentConverter2 = _interopRequireDefault(_ComponentConverter);

var _NumberConverter = __webpack_require__(27);

var _NumberConverter2 = _interopRequireDefault(_NumberConverter);

var _ObjectConverter = __webpack_require__(28);

var _ObjectConverter2 = _interopRequireDefault(_ObjectConverter);

var _ArrayConverter = __webpack_require__(29);

var _ArrayConverter2 = _interopRequireDefault(_ArrayConverter);

var _NodeInterface = __webpack_require__(18);

var _NodeInterface2 = _interopRequireDefault(_NodeInterface);

var _Utility = __webpack_require__(3);

var _Utility2 = _interopRequireDefault(_Utility);

var _GomlInterfaceImpl = __webpack_require__(19);

var _GomlInterfaceImpl2 = _interopRequireDefault(_GomlInterfaceImpl);

var _BooleanConverter = __webpack_require__(30);

var _BooleanConverter2 = _interopRequireDefault(_BooleanConverter);

var _GrimoireComponent = __webpack_require__(31);

var _GrimoireComponent2 = _interopRequireDefault(_GrimoireComponent);

var _StringArrayConverter = __webpack_require__(32);

var _StringArrayConverter2 = _interopRequireDefault(_StringArrayConverter);

var _StringConverter = __webpack_require__(33);

var _StringConverter2 = _interopRequireDefault(_StringConverter);

var _Constants = __webpack_require__(5);

var _Constants2 = _interopRequireDefault(_Constants);

var _ComponentDeclaration = __webpack_require__(16);

var _ComponentDeclaration2 = _interopRequireDefault(_ComponentDeclaration);

var _Component = __webpack_require__(8);

var _Component2 = _interopRequireDefault(_Component);

var _NodeDeclaration = __webpack_require__(34);

var _NodeDeclaration2 = _interopRequireDefault(_NodeDeclaration);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _Namespace = __webpack_require__(7);

var _Namespace2 = _interopRequireDefault(_Namespace);

var _NSDictionary = __webpack_require__(6);

var _NSDictionary2 = _interopRequireDefault(_NSDictionary);

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var GrimoireInterfaceImpl = function (_EEObject) {
    _inherits(GrimoireInterfaceImpl, _EEObject);

    function GrimoireInterfaceImpl() {
        _classCallCheck(this, GrimoireInterfaceImpl);

        var _this = _possibleConstructorReturn(this, (GrimoireInterfaceImpl.__proto__ || Object.getPrototypeOf(GrimoireInterfaceImpl)).apply(this, arguments));

        _this.nodeDeclarations = new _NSDictionary2.default();
        _this.converters = new _NSDictionary2.default();
        _this.componentDeclarations = new _NSDictionary2.default();
        _this.rootNodes = {};
        _this.loadTasks = [];
        _this.lib = {};
        _this.nodeDictionary = {};
        _this.componentDictionary = {};
        _this.debug = true;
        _this._registrationContext = _Constants2.default.defaultNamespace;
        return _this;
    }

    _createClass(GrimoireInterfaceImpl, [{
        key: "ns",

        /**
         * [obsolete] use `Namespace.define` instead of.
         * @param  {string} ns namespace URI to be used
         * @return {[type]}    the namespaced identity
         */
        value: function ns(_ns) {
            return function (name) {
                return _Namespace2.default.define(_ns).for(name);
            };
        }
    }, {
        key: "initialize",
        value: function initialize() {
            this.registerConverter("String", _StringConverter2.default);
            this.registerConverter("StringArray", _StringArrayConverter2.default);
            this.registerConverter("Boolean", _BooleanConverter2.default);
            this.registerConverter(_ArrayConverter2.default);
            this.registerConverter("Object", _ObjectConverter2.default);
            this.registerConverter(_EnumConverter2.default);
            this.registerConverter("Number", _NumberConverter2.default);
            this.registerConverter(_ComponentConverter2.default);
            this.registerConverter("NumberArray", _NumberArrayConverter2.default);
            this.registerComponent(_GrimoireComponent2.default);
            this.registerNode("grimoire-node-base", ["GrimoireComponent"]);
        }
        /**
         * Register plugins
         * @param  {(}      loadTask [description]
         * @return {[type]}          [description]
         */

    }, {
        key: "register",
        value: function register(loadTask) {
            this.loadTasks.push({ ns: this._registeringPluginNamespace, task: loadTask });
            this._registeringPluginNamespace = _Constants2.default.defaultNamespace;
        }
    }, {
        key: "resolvePlugins",
        value: function resolvePlugins() {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                var i, obj;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                i = 0;

                            case 1:
                                if (!(i < this.loadTasks.length)) {
                                    _context.next = 16;
                                    break;
                                }

                                obj = this.loadTasks[i];

                                this._registrationContext = obj.ns;
                                _context.prev = 4;
                                _context.next = 7;
                                return obj.task();

                            case 7:
                                _context.next = 13;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](4);

                                console.error("Error: loadTask of plugin '" + obj.ns + "' is failed.");
                                console.error(_context.t0);

                            case 13:
                                i++;
                                _context.next = 1;
                                break;

                            case 16:
                                this._registrationContext = _Constants2.default.defaultNamespace;
                                // resolveDependency
                                this.componentDeclarations.forEach(function (dec) {
                                    dec.resolveDependency();
                                });
                                this.nodeDeclarations.forEach(function (dec) {
                                    dec.resolveDependency();
                                });

                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 9]]);
            }));
        }
    }, {
        key: "registerComponent",
        value: function registerComponent(arg1, arg2, arg3) {
            var name = void 0;
            var obj = void 0;
            var superComponent = void 0;
            if (typeof arg1 === "string" || arg1 instanceof _NSIdentity2.default) {
                name = arg1;
                obj = arg2;
                superComponent = arg3;
            } else {
                obj = arg1;
                superComponent = arg2;
                if (obj.componentName == null) {
                    throw new Error("registering component has not 'componentName': " + obj);
                }
                name = obj.componentName;
            }
            name = this._ensureTobeNSIdentityOnRegister(name);
            if (this.componentDeclarations.get(name)) {
                throw new Error("component " + name.fqn + " is already registerd.");
            }
            if (typeof obj === "function" && !(obj.prototype instanceof _Component2.default)) {
                throw new Error("component constructor " + name.fqn + " must be inherits Component");
            }
            if (this.debug && !_Utility2.default.isCamelCase(name.name)) {
                console.warn("component " + name.name + " is registerd. but,it should be 'CamelCase'.");
            }
            var attrs = obj.attributes;
            if (!attrs) {
                throw new Error("component must has 'attributes'");
            }
            for (var key in attrs) {
                if (attrs[key].default === void 0) {
                    throw new Error("default value of attribute " + key + " in " + name.fqn + " must be not 'undefined'.");
                }
            }
            var dec = new _ComponentDeclaration2.default(name, obj, superComponent);
            this.componentDeclarations.set(name, dec);
            return dec;
        }
    }, {
        key: "registerNode",
        value: function registerNode(name) {
            var requiredComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var defaults = arguments[2];
            var superNode = arguments[3];
            var freezeAttributes = arguments[4];

            var registerId = this._ensureTobeNSIdentityOnRegister(name);
            if (this.nodeDeclarations.get(registerId)) {
                throw new Error("gomlnode " + registerId.fqn + " is already registerd.");
            }
            if (this.debug && !_Utility2.default.isSnakeCase(registerId.name)) {
                console.warn("node " + registerId.name + " is registerd. but,it should be 'snake-case'.");
            }
            var declaration = new _NodeDeclaration2.default(registerId, requiredComponents || [], defaults || {}, superNode, freezeAttributes);
            this.nodeDeclarations.set(registerId, declaration);
            return declaration;
        }
    }, {
        key: "getCompanion",
        value: function getCompanion(scriptTag) {
            var root = this.getRootNode(scriptTag);
            if (root) {
                return root.companion;
            } else {
                throw new Error("scriptTag is not goml");
            }
        }
    }, {
        key: "addRootNode",
        value: function addRootNode(tag, rootNode) {
            if (!rootNode) {
                throw new Error("can not register null to rootNodes.");
            }
            tag.setAttribute("x-rootNodeId", rootNode.id);
            this.rootNodes[rootNode.id] = rootNode;
            rootNode.companion.set(this.ns(_Constants2.default.defaultNamespace)("scriptElement"), tag);
            // awake and mount tree.
            rootNode.setMounted(true);
            rootNode.broadcastMessage("treeInitialized", {
                ownerScriptTag: tag,
                id: rootNode.id
            });
            rootNode.sendInitializedMessage({
                ownerScriptTag: tag,
                id: rootNode.id
            });
            return rootNode.id;
        }
    }, {
        key: "getRootNode",
        value: function getRootNode(scriptTag) {
            var id = scriptTag.getAttribute("x-rootNodeId");
            if (id) {
                var ret = this.rootNodes[id];
                if (!ret) {
                    throw new Error("threr is no rootNode has id " + id);
                }
                return ret;
            } else {
                return null;
            }
        }
    }, {
        key: "noConflict",
        value: function noConflict() {
            window["gr"] = this.noConflictPreserve;
        }
    }, {
        key: "queryRootNodes",
        value: function queryRootNodes(query) {
            var scriptTags = document.querySelectorAll(query);
            var nodes = [];
            for (var i = 0; i < scriptTags.length; i++) {
                var node = this.getRootNode(scriptTags.item(i));
                if (node) {
                    nodes.push(node);
                }
            }
            return nodes;
        }
    }, {
        key: "registerConverter",
        value: function registerConverter(arg1, converter) {
            if (converter) {
                this.registerConverter({ name: this._ensureTobeNSIdentityOnRegister(arg1), verify: function verify() {
                        return true;
                    }, convert: converter });
                return;
            }
            var dec = arg1;
            this.converters.set(this._ensureTobeNSIdentityOnRegister(dec.name), dec);
        }
    }, {
        key: "overrideDeclaration",
        value: function overrideDeclaration(targetDeclaration, arg2, defaults) {
            var dec = this.nodeDeclarations.get(targetDeclaration);
            if (!dec) {
                throw new Error("attempt not-exist node declaration : " + _Ensure2.default.tobeNSIdentity(targetDeclaration).name);
            }
            if (!dec.resolvedDependency) {
                dec.resolveDependency();
            }
            if (defaults) {
                var additionalC = arg2;
                for (var i = 0; i < additionalC.length; i++) {
                    dec.addDefaultComponent(additionalC[i]);
                }
                dec.defaultAttributes.pushDictionary(_Ensure2.default.tobeNSDictionary(defaults));
            } else if (Array.isArray(arg2)) {
                for (var _i = 0; _i < arg2.length; _i++) {
                    dec.addDefaultComponent(arg2[_i]);
                }
            } else {
                dec.defaultAttributes.pushDictionary(_Ensure2.default.tobeNSDictionary(arg2));
            }
            return dec;
        }
        /**
         * This method is not for users.
         * Just for unit testing.
         *
         * Clear all configuration that GrimoireInterface contain.
         */

    }, {
        key: "clear",
        value: function clear() {
            this.nodeDeclarations.clear();
            this.componentDeclarations.clear();
            this.converters.clear();
            for (var key in this.rootNodes) {
                delete this.rootNodes[key];
            }
            for (var _key in this.nodeDictionary) {
                delete this.nodeDictionary[_key];
            }
            for (var _key2 in this.componentDictionary) {
                delete this.componentDictionary[_key2];
            }
            this.loadTasks.splice(0, this.loadTasks.length);
            this._registeringPluginNamespace = _Constants2.default.defaultNamespace;
            this.initialize();
        }
    }, {
        key: "extendGrimoireInterface",
        value: function extendGrimoireInterface(name, func) {
            if (this[name]) {
                throw new Error("gr." + name + " can not extend.it is already exist.");
            }
            this[name] = func.bind(this);
        }
    }, {
        key: "extendGomlInterface",
        value: function extendGomlInterface(name, func) {
            if (_GomlInterfaceImpl2.default[name]) {
                throw new Error("gr." + name + " can not extend.it is already exist.");
            }
            _GomlInterfaceImpl2.default[name] = func.bind(this);
        }
    }, {
        key: "extendNodeInterface",
        value: function extendNodeInterface(name, func) {
            if (_NodeInterface2.default[name]) {
                throw new Error("gr." + name + " can not extend.it is already exist.");
            }
            _NodeInterface2.default[name] = func.bind(this);
        }
        /**
         * use for notify GrimoireInterface of plugin namespace to be ragister.
         * notified namespace will use when resolve loadTask of the plugin.
         * @param {string} namespace namespace of plugin to be ragister.
         */

    }, {
        key: "notifyRegisteringPlugin",
        value: function notifyRegisteringPlugin(namespace) {
            var res = /^[Gg]rimoire(?:js|JS)?-(.*)$/.exec(namespace);
            if (res) {
                namespace = res[1];
            }
            this._registeringPluginNamespace = namespace;
        }
    }, {
        key: "_ensureNameTobeConstructor",
        value: function _ensureNameTobeConstructor(component) {
            if (!component) {
                return null;
            }
            if (typeof component === "function") {
                return component;
            } else if (typeof component === "string") {
                return this._ensureNameTobeConstructor(_Ensure2.default.tobeNSIdentity(component));
            } else {
                // here NSIdentity.
                var c = this.componentDeclarations.get(component);
                if (!c) {
                    return null;
                }
                return c.ctor;
            }
        }
    }, {
        key: "_ensureTobeNSIdentityOnRegister",
        value: function _ensureTobeNSIdentityOnRegister(name) {
            if (!name) {
                return null;
            }
            if (typeof name === "string") {
                if (name.indexOf("|") !== -1) {
                    return _NSIdentity2.default.fromFQN(name);
                }
                return _NSIdentity2.default.fromFQN(_Namespace2.default.define(this._registrationContext), name);
            } else {
                return name;
            }
        }
    }, {
        key: "initializedEventHandler",
        get: function get() {
            return _GomlLoader2.default.initializedEventHandlers;
        }
    }]);

    return GrimoireInterfaceImpl;
}(_EEObject3.default);

exports.default = GrimoireInterfaceImpl;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Exception representing uncought error caused in message function.
 * Do not thorow this error manually.
 */
var MessageException = function (_Error) {
    _inherits(MessageException, _Error);

    function MessageException(node, component, messageName, error) {
        _classCallCheck(this, MessageException);

        var _this = _possibleConstructorReturn(this, (MessageException.__proto__ || Object.getPrototypeOf(MessageException)).call(this));

        _this.node = node;
        _this.component = component;
        _this.messageName = messageName;
        _this.error = error;
        /**
         * If this flag was set by events, message system will ignore this exception.
         */
        _this.handled = false;
        _this._isMessageException = true;
        var isMessageException = error._isMessageException;
        if (!isMessageException) {
            var components = _this.node.getComponents();
            var componentMessage = "";
            for (var i = 0; i < components.length; i++) {
                var singleComponent = components[i];
                var marker = "";
                if (_this.component === singleComponent) {
                    marker = "<<<<<<<<< This component";
                }
                componentMessage += "  (" + i + ")  <" + singleComponent.name.fqn + ">  " + marker + "\n\n   Attributes:\n";
                singleComponent.attributes.forEach(function (a) {
                    try {
                        componentMessage += "    " + a.name.fqn + " --- " + a.Value + "\n";
                    } catch (e) {
                        componentMessage += "    " + a.name.fqn + " --- Failed to fetch\n";
                    }
                });
                componentMessage += "\n\n";
            }
            _this.message = "[" + error.name + "]: " + error.message + "\n\nThis exception was thrown in message function. Following information are snapshot of GOML tree status.\n\n* Node:  <" + node.toString() + ">\n* Component:  <" + component.name.fqn + ">\n* Message:  " + messageName + " \n\n* Node map:\n " + node.toStructualString("--------(Error was thrown from " + component.name.fqn + " component of this node.)") + "\n\n* Components of this node:\n" + componentMessage + "\n\n";
        } else {
            _this.message = error.message + "\n [Message stack]: " + _this.messageName + " at <" + _this.component.name.fqn + "> on <" + _this.node.toString() + ">\n";
        }
        _this.stack = error.stack;
        var proto = Object.getPrototypeOf(_this);
        proto.name = "MessageException";
        proto.message = _this.message;
        return _this;
    }

    _createClass(MessageException, [{
        key: "toString",
        value: function toString() {
            return this.message;
        }
    }]);

    return MessageException;
}(Error);

exports.default = MessageException;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var XMLHttpRequestAsync = function () {
    function XMLHttpRequestAsync() {
        _classCallCheck(this, XMLHttpRequestAsync);
    }

    _createClass(XMLHttpRequestAsync, null, [{
        key: "send",
        value: function send(xhr, data) {
            return new Promise(function (resolve, reject) {
                xhr.onload = function (e) {
                    resolve(e);
                };
                xhr.onerror = function (e) {
                    reject(e);
                };
                xhr.send(data);
            });
        }
    }]);

    return XMLHttpRequestAsync;
}();

exports.default = XMLHttpRequestAsync;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 列挙のためのコンバータ。
 * 属性宣言に`table`パラメータが必要です。
 * `table`パラメータは列挙する文字列から数値への連想配列です。
 * 数値の場合、そのまま返します。
 * 文字列の場合、テーブルの対応する値を返します。
 */
exports.default = {
    name: "Enum",
    verify: function verify(attr) {
        if (!attr.declaration["table"]) {
            throw new Error("Enum converter needs to be specified table in attribute dictionary");
        }
    },
    convert: function convert(val, attr) {
        if (typeof val === "number") {
            return val;
        }
        if (typeof val === "string") {
            var result = attr.declaration["table"][val];
            if (!result) {
                throw new Error("Specified value is not exisiting in the relation table");
            }
            return result;
        }
    }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NumberArrayConverter;
function NumberArrayConverter(val) {
    if (val instanceof Array) {
        return val;
    }
    if (typeof val === "string") {
        var splitted = val.split(",");
        return splitted.map(function (s) {
            return Number.parseFloat(s);
        });
    }
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

var _Component = __webpack_require__(8);

var _Component2 = _interopRequireDefault(_Component);

var _GomlNode = __webpack_require__(10);

var _GomlNode2 = _interopRequireDefault(_GomlNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * コンポーネントのためのコンバータです。
 * 属性宣言に`target`パラメータの指定が必要です。
 * nullに対してはnullを返します。
 * `gomlnode`に対しては、`target`パラメータの値で`getComponent`した結果を返します。
 * `Component`に対しては、`target`パラメータと型が一致していればそのまま返します。そうでなければ、例外を投げます。
 * 文字列の場合、ノードに対するクエリとして解釈され、取得されたノードに対して`getComponent`されます。
 */
exports.default = {
    name: "Component",
    verify: function verify(attr) {
        if (!attr.declaration["target"]) {
            throw new Error("Component converter require to be specified target");
        }
    },
    convert: function convert(val, attr) {
        if (val === null) {
            return null;
        }
        if (val instanceof _GomlNode2.default) {
            return val.getComponent(attr.declaration["target"]);
        } else if (val instanceof _Component2.default) {
            if (val.name.fqn === _Ensure2.default.tobeNSIdentity(attr.declaration["target"]).fqn) {
                return val;
            } else {
                throw new Error("Specified component must be " + attr.declaration["target"]);
            }
        } else {
            var n = attr.tree(val).first();
            if (n) {
                return n.getComponent(attr.declaration["target"]);
            }
            return null;
        }
    }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NumberConverter;
/**
 * converter for number value.
 * number,string,null will be converted.
 * Array<number> also convertable only if length equivalent to 1.
 * @param  {any}    val [description]
 * @return {number}     [description]
 */
function NumberConverter(val) {
    if (typeof val === "number") {
        return val;
    } else if (typeof val === "string") {
        return Number.parseFloat(val);
    } else if (val === null) {
        return null;
    } else if (Array.isArray(val) && val.length === 1) {
        return val[0];
    }
    return undefined;
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ObjectConverter;
/**
 * オブジェクトのコンバータ。
 * 値をそのまま返します。
 * @param  {any} val [description]
 * @return {any}     [description]
 */
function ObjectConverter(val) {
  return val;
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var splitter = " ";
var escape = "\\";
/**
 * 配列のためのコンバータ。
 * 属性宣言にパラメータ`type`が必要です。
 * このパラメータは配列の要素の型のためのコンバータ名です。
 * このコンバータは、配列が与えられたらその内容すべてを、`type`で指定されたコンバータを通して生成した新しい配列を返します。
 * 文字列が与えられたとき、*半角スペース*で区切られた文字列ごとに配列に分割して同様の処理を行います。
 * ただし、`\`(バックスラッシュ)で*半角スペースをエスケープできます*
 */
exports.default = {
    name: "Array",
    verify: function verify(attr) {
        if (!attr.declaration["type"]) {
            throw new Error("Array converter needs to be specified type in attribute declaration.");
        }
    },
    convert: function convert(val, attr) {
        var converter = _GrimoireInterface2.default.converters.get(attr.declaration["type"]);
        if (!converter) {
            throw new Error("converter " + attr.declaration["type"] + " is not registerd.");
        }
        if (Array.isArray(val)) {
            return val.map(function (v) {
                return converter.convert(v, attr);
            });
        }
        if (typeof val === "string") {
            var ar = val.split(splitter);
            for (var i = 0; i < ar.length; i++) {
                var s = ar[i];
                if (s[s.length - 1] === escape) {
                    if (i === ar.length - 1) {
                        ar[i] = s.substring(0, s.length - escape.length) + splitter;
                    } else {
                        ar[i] = s.substring(0, s.length - escape.length) + splitter + ar[i + 1];
                        ar.splice(i + 1, 1);
                    }
                }
            }
            return ar.map(function (v) {
                return converter.convert(v, attr);
            });
        }
        return null;
    }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BooleanConverter;
/**
 * booleanのためのコンバータです。
 * booleanはそのまま通します。
 * 文字列は、`true`,`false`のみ通します。
 * @param  {any}       val  [description]
 * @param  {Attribute} attr [description]
 * @return {any}            [description]
 */
function BooleanConverter(val) {
    if (typeof val === "boolean") {
        return val;
    } else if (typeof val === "string") {
        switch (val) {
            case "true":
                return true;
            case "false":
                return false;
        }
    }
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component2 = __webpack_require__(8);

var _Component3 = _interopRequireDefault(_Component2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GrimoireComponent = function (_Component) {
    _inherits(GrimoireComponent, _Component);

    function GrimoireComponent() {
        _classCallCheck(this, GrimoireComponent);

        return _possibleConstructorReturn(this, (GrimoireComponent.__proto__ || Object.getPrototypeOf(GrimoireComponent)).apply(this, arguments));
    }

    _createClass(GrimoireComponent, [{
        key: "$awake",
        value: function $awake() {
            var node = this.node;
            node.resolveAttributesValue();
            this.getAttributeRaw("id").watch(function (attr) {
                node.element.id = attr ? attr : "";
            }, true, true);
            this.getAttributeRaw("class").watch(function (attr) {
                node.element.className = Array.isArray(attr) ? attr.join(" ") : "";
            }, true, true);
            this.getAttributeRaw("enabled").watch(function (attr) {
                node["_enabled"] = attr;
                var p = node.parent;
                node.notifyActivenessUpdate(p ? p.isActive && node.enabled : node.enabled);
            }, false, true);
            node["_enabled"] = this.getAttribute("enabled");
            node["_isActive"] = node.parent ? node.parent.isActive && node.enabled : node.enabled;
        }
    }]);

    return GrimoireComponent;
}(_Component3.default);

exports.default = GrimoireComponent;

GrimoireComponent.componentName = "GrimoireComponent";
GrimoireComponent.attributes = {
    id: {
        converter: "String",
        default: null
    },
    class: {
        converter: "StringArray",
        default: null
    },
    enabled: {
        converter: "Boolean",
        default: true
    }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StringArrayConverter;
function StringArrayConverter(val) {
    if (Array.isArray(val) || !val) {
        return val;
    }
    if (typeof val === "string") {
        return val.split(" ");
    }
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StringConverter;
function StringConverter(val) {
    if (typeof val === "string") {
        return val;
    } else if (!val) {
        return val;
    } else if (typeof val.toString === "function") {
        return val.toString();
    }
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

var _NSDictionary = __webpack_require__(6);

var _NSDictionary2 = _interopRequireDefault(_NSDictionary);

var _NSSet = __webpack_require__(35);

var _NSSet2 = _interopRequireDefault(_NSSet);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _IdResolver = __webpack_require__(4);

var _IdResolver2 = _interopRequireDefault(_IdResolver);

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NodeDeclaration = function () {
    function NodeDeclaration(name, _defaultComponents, _defaultAttributes, _superNode) {
        var _freezeAttributes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

        _classCallCheck(this, NodeDeclaration);

        this.name = name;
        this._defaultComponents = _defaultComponents;
        this._defaultAttributes = _defaultAttributes;
        this._superNode = _superNode;
        this._freezeAttributes = _freezeAttributes;
        this.defaultAttributes = new _NSDictionary2.default();
        this.idResolver = new _IdResolver2.default();
        this._resolvedDependency = false;
        if (!this._superNode && this.name.name !== "grimoire-node-base") {
            this._superNode = new _NSIdentity2.default("grimoirejs.grimoire-node-base");
        }
        this._freezeAttributes = this._freezeAttributes || [];
    }

    _createClass(NodeDeclaration, [{
        key: "addDefaultComponent",
        value: function addDefaultComponent(componentName) {
            var componentId = _Ensure2.default.tobeNSIdentity(componentName);
            this.defaultComponents.push(componentId);
            if (this._defaultComponentsActual) {
                this._defaultComponentsActual.push(componentId);
            }
        }
        /**
         * resolve requiredComponents,superNode,defaults and freezeAttributes,
         * throw error if they have any ambiguity.
         * デフォルトコンポーネント、スーパノード、デフォルト値、フリーズ値の名前解決。曖昧は例外
         */

    }, {
        key: "resolveDependency",
        value: function resolveDependency() {
            var _this = this;

            if (this._resolvedDependency) {
                return false;
            }
            this.defaultComponents = new _NSSet2.default(this._defaultComponents.map(function (name) {
                return _Ensure2.default.tobeNSIdentity(name);
            }));
            for (var key in this._defaultAttributes) {
                var value = this._defaultAttributes[key];
                this.defaultAttributes.set(_NSIdentity2.default.fromFQN(key), value);
            }
            this.superNode = this._superNode ? _Ensure2.default.tobeNSIdentity(this._superNode) : void 0;
            this._resolveInherites();
            this._defaultComponentsActual.forEach(function (id) {
                var dec = _GrimoireInterface2.default.componentDeclarations.get(id);
                dec.idResolver.foreach(function (fqn) {
                    _this.idResolver.add(_NSIdentity2.default.fromFQN(fqn));
                });
            });
            this.freezeAttributes = new _NSSet2.default(this._freezeAttributes.map(function (name) {
                return _Ensure2.default.tobeNSIdentity(name);
            }));
            this._resolvedDependency = true;
            return true;
        }
    }, {
        key: "_resolveInherites",
        value: function _resolveInherites() {
            if (!this.superNode) {
                this._defaultComponentsActual = this.defaultComponents;
                this._defaultAttributesActual = this.defaultAttributes;
                return;
            }
            var superNode = _GrimoireInterface2.default.nodeDeclarations.get(this.superNode);
            superNode.resolveDependency();
            var inheritedDefaultComponents = superNode.defaultComponentsActual;
            var inheritedDefaultAttribute = superNode.defaultAttributesActual;
            this._defaultComponentsActual = inheritedDefaultComponents.clone().merge(this.defaultComponents);
            this._defaultAttributesActual = inheritedDefaultAttribute.clone().pushDictionary(this.defaultAttributes);
        }
    }, {
        key: "resolvedDependency",
        get: function get() {
            return this._resolvedDependency;
        }
    }, {
        key: "defaultComponentsActual",
        get: function get() {
            if (!this._resolvedDependency) {
                throw new Error(this.name.fqn + " is not resolved dependency!");
            }
            return this._defaultComponentsActual;
        }
    }, {
        key: "defaultAttributesActual",
        get: function get() {
            if (!this._resolvedDependency) {
                throw new Error(this.name.fqn + " is not resolved dependency!");
            }
            return this._defaultAttributesActual;
        }
    }]);

    return NodeDeclaration;
}();

exports.default = NodeDeclaration;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * set of NSIdentity
 * @param  {NSIdentity[]} array [description]
 * @return {NSSet}              [description]
 */
var NSSet = function () {
    function NSSet(content) {
        _classCallCheck(this, NSSet);

        this._content = {};
        if (content) {
            this.pushArray(content);
        }
    }

    _createClass(NSSet, [{
        key: "push",
        value: function push(item) {
            if (!this._content[item.fqn]) {
                this._content[item.fqn] = item;
                return true;
            }
            return false;
        }
    }, {
        key: "pushArray",
        value: function pushArray(item) {
            var _this = this;

            item.forEach(function (v) {
                _this.push(v);
            });
            return this;
        }
    }, {
        key: "toArray",
        value: function toArray() {
            var ret = [];
            for (var key in this._content) {
                ret.push(this._content[key]);
            }
            return ret;
        }
    }, {
        key: "clone",
        value: function clone() {
            var newSet = new NSSet();
            for (var key in this._content) {
                newSet.push(this._content[key]);
            }
            return newSet;
        }
    }, {
        key: "merge",
        value: function merge(other) {
            this.pushArray(other.toArray());
            return this;
        }
    }, {
        key: "forEach",
        value: function forEach(func) {
            for (var key in this._content) {
                func(this._content[key]);
            }
            return this;
        }
    }], [{
        key: "fromArray",
        value: function fromArray(array) {
            var nSet = new NSSet();
            nSet.pushArray(array);
            return nSet;
        }
    }]);

    return NSSet;
}();

exports.default = NSSet;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AttributeManager = __webpack_require__(20);

var _AttributeManager2 = _interopRequireDefault(_AttributeManager);

var _Constants = __webpack_require__(5);

var _Constants2 = _interopRequireDefault(_Constants);

var _EEObject = __webpack_require__(12);

var _EEObject2 = _interopRequireDefault(_EEObject);

var _Ensure = __webpack_require__(2);

var _Ensure2 = _interopRequireDefault(_Ensure);

var _IDObject = __webpack_require__(13);

var _IDObject2 = _interopRequireDefault(_IDObject);

var _IdResolver = __webpack_require__(4);

var _IdResolver2 = _interopRequireDefault(_IdResolver);

var _MessageException = __webpack_require__(22);

var _MessageException2 = _interopRequireDefault(_MessageException);

var _Namespace = __webpack_require__(7);

var _Namespace2 = _interopRequireDefault(_Namespace);

var _NSDictionary = __webpack_require__(6);

var _NSDictionary2 = _interopRequireDefault(_NSDictionary);

var _NSIdentity = __webpack_require__(1);

var _NSIdentity2 = _interopRequireDefault(_NSIdentity);

var _NSSet = __webpack_require__(35);

var _NSSet2 = _interopRequireDefault(_NSSet);

var _Types = __webpack_require__(38);

var _Types2 = _interopRequireDefault(_Types);

var _Utility = __webpack_require__(3);

var _Utility2 = _interopRequireDefault(_Utility);

var _XMLHttpRequestAsync = __webpack_require__(23);

var _XMLHttpRequestAsync2 = _interopRequireDefault(_XMLHttpRequestAsync);

var _XMLReader = __webpack_require__(11);

var _XMLReader2 = _interopRequireDefault(_XMLReader);

var _GrimoireComponent = __webpack_require__(31);

var _GrimoireComponent2 = _interopRequireDefault(_GrimoireComponent);

var _ArrayConverter = __webpack_require__(29);

var _ArrayConverter2 = _interopRequireDefault(_ArrayConverter);

var _BooleanConverter = __webpack_require__(30);

var _BooleanConverter2 = _interopRequireDefault(_BooleanConverter);

var _ComponentConverter = __webpack_require__(26);

var _ComponentConverter2 = _interopRequireDefault(_ComponentConverter);

var _EnumConverter = __webpack_require__(24);

var _EnumConverter2 = _interopRequireDefault(_EnumConverter);

var _NumberArrayConverter = __webpack_require__(25);

var _NumberArrayConverter2 = _interopRequireDefault(_NumberArrayConverter);

var _NumberConverter = __webpack_require__(27);

var _NumberConverter2 = _interopRequireDefault(_NumberConverter);

var _ObjectConverter = __webpack_require__(28);

var _ObjectConverter2 = _interopRequireDefault(_ObjectConverter);

var _StringArrayConverter = __webpack_require__(32);

var _StringArrayConverter2 = _interopRequireDefault(_StringArrayConverter);

var _StringConverter = __webpack_require__(33);

var _StringConverter2 = _interopRequireDefault(_StringConverter);

var _GomlInterfaceImpl = __webpack_require__(19);

var _GomlInterfaceImpl2 = _interopRequireDefault(_GomlInterfaceImpl);

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

var _GrimoireInterfaceImpl = __webpack_require__(21);

var _GrimoireInterfaceImpl2 = _interopRequireDefault(_GrimoireInterfaceImpl);

var _NodeInterface = __webpack_require__(18);

var _NodeInterface2 = _interopRequireDefault(_NodeInterface);

var _Attribute = __webpack_require__(17);

var _Attribute2 = _interopRequireDefault(_Attribute);

var _Component = __webpack_require__(8);

var _Component2 = _interopRequireDefault(_Component);

var _ComponentDeclaration = __webpack_require__(16);

var _ComponentDeclaration2 = _interopRequireDefault(_ComponentDeclaration);

var _GomlLoader = __webpack_require__(14);

var _GomlLoader2 = _interopRequireDefault(_GomlLoader);

var _GomlNode = __webpack_require__(10);

var _GomlNode2 = _interopRequireDefault(_GomlNode);

var _GomlParser = __webpack_require__(9);

var _GomlParser2 = _interopRequireDefault(_GomlParser);

var _NodeDeclaration = __webpack_require__(34);

var _NodeDeclaration2 = _interopRequireDefault(_NodeDeclaration);

var _NodeUtility = __webpack_require__(15);

var _NodeUtility2 = _interopRequireDefault(_NodeUtility);

var _main = __webpack_require__(39);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __VERSION__ = "0.19.3";
var __NAME__ = "grimoirejs";

var __EXPOSE__ = {
    "Base": {
        "AttributeManager": _AttributeManager2.default,
        "Constants": _Constants2.default,
        "EEObject": _EEObject2.default,
        "Ensure": _Ensure2.default,
        "IDObject": _IDObject2.default,
        "IdResolver": _IdResolver2.default,
        "MessageException": _MessageException2.default,
        "Namespace": _Namespace2.default,
        "NSDictionary": _NSDictionary2.default,
        "NSIdentity": _NSIdentity2.default,
        "NSSet": _NSSet2.default,
        "Types": _Types2.default,
        "Utility": _Utility2.default,
        "XMLHttpRequestAsync": _XMLHttpRequestAsync2.default,
        "XMLReader": _XMLReader2.default
    },
    "Components": {
        "GrimoireComponent": _GrimoireComponent2.default
    },
    "Converters": {
        "ArrayConverter": _ArrayConverter2.default,
        "BooleanConverter": _BooleanConverter2.default,
        "ComponentConverter": _ComponentConverter2.default,
        "EnumConverter": _EnumConverter2.default,
        "NumberArrayConverter": _NumberArrayConverter2.default,
        "NumberConverter": _NumberConverter2.default,
        "ObjectConverter": _ObjectConverter2.default,
        "StringArrayConverter": _StringArrayConverter2.default,
        "StringConverter": _StringConverter2.default
    },
    "Interface": {
        "GomlInterfaceImpl": _GomlInterfaceImpl2.default,
        "GrimoireInterface": _GrimoireInterface2.default,
        "GrimoireInterfaceImpl": _GrimoireInterfaceImpl2.default,
        "NodeInterface": _NodeInterface2.default
    },
    "Node": {
        "Attribute": _Attribute2.default,
        "Component": _Component2.default,
        "ComponentDeclaration": _ComponentDeclaration2.default,
        "GomlLoader": _GomlLoader2.default,
        "GomlNode": _GomlNode2.default,
        "GomlParser": _GomlParser2.default,
        "NodeDeclaration": _NodeDeclaration2.default,
        "NodeUtility": _NodeUtility2.default
    }
};
var __BASE__ = (0, _main2.default)();
Object.assign(__EXPOSE__, {
    __VERSION__: __VERSION__,
    __NAME__: __NAME__
});
Object.assign(__BASE__ || {}, __EXPOSE__);
window["GrimoireJS"]["__VERSION__"] = __VERSION__;
exports.default = __BASE__;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = null;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function () {
    GrimoireInitializer.initialize();
    _GrimoireInterface2.default.noConflictPreserve = window["gr"];
    return window["gr"] = window["GrimoireJS"] = _GrimoireInterface2.default;
};

var _GrimoireInterface = __webpack_require__(0);

var _GrimoireInterface2 = _interopRequireDefault(_GrimoireInterface);

var _GomlLoader = __webpack_require__(14);

var _GomlLoader2 = _interopRequireDefault(_GomlLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

/**
 * Provides procedures for initializing.
 */
var GrimoireInitializer = function () {
    function GrimoireInitializer() {
        _classCallCheck(this, GrimoireInitializer);
    }

    _createClass(GrimoireInitializer, null, [{
        key: "initialize",

        /**
         * Start initializing
         * @return {Promise<void>} The promise which will be resolved when all of the Goml script was loaded.
         */
        value: function initialize() {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                GrimoireInitializer._copyGLConstants();
                                _GrimoireInterface2.default.initialize();
                                _context.next = 5;
                                return GrimoireInitializer._waitForDOMLoading();

                            case 5:
                                GrimoireInitializer._logVersions();
                                _context.next = 8;
                                return _GrimoireInterface2.default.resolvePlugins();

                            case 8:
                                _context.next = 10;
                                return _GomlLoader2.default.loadForPage();

                            case 10:
                                _context.next = 15;
                                break;

                            case 12:
                                _context.prev = 12;
                                _context.t0 = _context["catch"](0);

                                console.error(_context.t0);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 12]]);
            }));
        }
        /**
         * Ensure WebGLRenderingContext.[CONSTANTS] is exisiting.
         * Some of the browsers contains them in prototype.
         */

    }, {
        key: "_copyGLConstants",
        value: function _copyGLConstants() {
            if (WebGLRenderingContext.ONE) {
                // Assume the CONSTANTS are already in WebGLRenderingContext
                // Chrome,Firefox,IE,Edge...
                return;
            }
            // Otherwise like ""Safari""
            for (var propName in WebGLRenderingContext.prototype) {
                if (/^[A-Z]/.test(propName)) {
                    var property = WebGLRenderingContext.prototype[propName];
                    WebGLRenderingContext[propName] = property;
                }
            }
        }
        /**
         * Obtain the promise object which will be resolved when DOMContentLoaded event was rised.
         * @return {Promise<void>} the promise
         */

    }, {
        key: "_waitForDOMLoading",
        value: function _waitForDOMLoading() {
            return new Promise(function (resolve) {
                window.addEventListener("DOMContentLoaded", function () {
                    resolve();
                });
            });
        }
    }, {
        key: "_logVersions",
        value: function _logVersions() {
            var gr = _GrimoireInterface2.default;
            if (!gr.debug) {
                return;
            }
            var log = "%cGrimoire.js v" + gr["__VERSION__"] + "\nplugins:\n\n";
            var i = 1;
            for (var key in gr.lib) {
                var plugin = gr.lib[key];
                log += "  " + i + " : " + (plugin.__NAME__ || key) + "@" + plugin.__VERSION__ + "\n";
                i++;
            }
            log += "\nTo suppress this message,please inject a line \"gr.debug = false;\" on the initializing timing.";
            console.log(log, "color:#44F;font-weight:bold;");
        }
    }]);

    return GrimoireInitializer;
}();
/**
 * Just start the process.
 */

/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs/register/index.js
// module id = 301
// module chunks = 0